import React from 'react';

export const SCHOLARS2025: {
  name: string;
  teams: {
    name: string;
    school: string;
    country: string;
    photo?: string;
    description?: string;
  }[];
}[] = [
  {
    name: 'Oceania & Southeast Asia',
    teams: [
      {
        name: 'ECOSIP',
        school: 'CIA FIRST International School',
        country: 'Cambodia',
        photo: '/images/scholars2025/ecosip.webp',
        description:
          "Cambodia is currently facing a severe plastic crisis. The Mekong River, important for Cambodian livelihoods, carries up to 40,000 tonnes of plastic into oceans annually. In Phnom Penh, 10 million plastic bags are used daily, contributing to over 3,000 tonnes of waste. Cambodia has made it's goal to achieve carbon neutrality by 2050. To support Cambodia's transition into carbon neutrality, we have developed the \"Ecosip\" straw which is both edible and biodegradable and made from locally sourced Cambodian rice. We aim to create a simple yet effective solution that the Cambodian public will adopt especially in a country where environmental education and awareness are limited. Remember helping towards sustainability in your community doesn't require big fancy ideas, often all it takes is a small change in our daily habits.",
      },
      {
        name: 'Growing Guardians',
        school: "St Cuthbert's College",
        country: 'New Zealand',
        photo: '/images/scholars2025/growing.webp',
        description:
          'Youth worldwide face excessive exposure to fear-based climate narratives, intergenerational disconnect, and a lack of positive, actionable solutions, causing some students to suffer from climate anxiety whilst others succumb to climate apathy.\n' +
          '\n' +
          'To address this, Growing Guardians offers an innovative, action based educational resource for students aged 8-13. Youth are the future of our planet, and the habits they form today will shape the world they inherit. Our solution equips them with the knowledge and connection needed to nurture sustainable habits, transforming climate uncertainty into meaningful action. \n' +
          '\n' +
          'Growing Guardians empowers youth to protect and restore their natural environment, fostering lifelong stewardship.',
      },
      {
        name: 'Kultibado',
        school: 'International School Manila',
        country: 'Philippines',
        photo: '/images/scholars2025/kultibado.webp',
        description:
          'In the Philippines, 30% of agricultural produce goes to waste due to supply-chain inefficiencies. This contributes to methane emissions, severe economic losses, and reduced access to nutritious meals. \n\n' +
          'Our solution, “Kultibado”, is an innovative-web-app that bridges the gap between farmers, consumers, & cooperatives (groups that consolidate transportation resources). By eliminating price-controlling-middlemen, Kultibado enables farmers to earn fairer prices and provides consumers with affordable produce. \n\n' +
          'Kultibado’s wider market access empowers cooperatives to sell surplus and visually-unappealing produce, ultimately minimizing food waste. Our quality-assurance, multi-cooperative partnerships, robust support-networks, and user-friendly tools set us apart. \n\n' +
          'Become a modern-day hero by supporting Kultibado’s journey!',
      },
      {
        name: 'Leafy',
        school: 'Summit Education',
        country: 'Vietnam',
        photo: '/images/scholars2025/leafy.webp',
        description:
          'With 37/40 of the world’s most polluted cities in South East Asia, air pollution here is alarming. The region’s rising population continuously requires more construction for accommodation and industries, rendering it difficult to incorporate sufficient space for greeneries.\n' +
          ' \n' +
          'To address this, Leafy proposes an algae-based ‘’paint’’ that actively photosynthesizes while directly and aesthetically applied to city buildings. The product contains a durable algae suspension in a protective gel base, and distinguishes itself from existing formulations with a more diverse color range. We are seeking expert guidance and collaboration to formulate and showcase the environmental benefits of this algae-based solution.',
      },
      {
        name: 'Terra-D',
        school: 'i-IVY',
        country: 'Vietnam',
        photo: '/images/scholars2025/terrad.webp',
        description:
          'Coming from Vietnam, we are cognizant of the lingering dioxin contamination in agricultural soil, particularly from the use of the toxic defoliant Agent Orange during the Vietnam War. Besides chemical warfare, dioxin contamination in soil is also a growing global crisis, stemming from industrial activities like waste incineration and herbicide production.\n' +
          '\n' +
          'We developed a biofertilizer combining four fungal strains with biochar made from farming byproducts to remediate soil, enhance crop yields, and improve soil structure. While traditional dioxin remediation methods can cost millions of dollars, Terra-D offers farmers an accessible way to restore soil health while building resilient agricultural systems',
      },
    ],
  },
  {
    name: 'Asia',
    teams: [
      {
        name: 'Aqualliance',
        school: 'Rajuk Uttara Model College & Notre Dame College',
        country: 'Bangladesh',
        photo: '/images/scholars2025/aqualliance.webp',
        description:
          'Team Aqualliance is a passionate group of four curious minds from Rajuk Uttara Model College and Notre Dame College, united by our drive to solve real-world problems. Our team—Swapnil Sarker, Abdullah Al Ujayer, Md Abu Sayem, and Prantique Roy—shares a love for late-night brainstorming and innovative thinking. Every year, data centers consume enough water to fill roughly 80,000 Olympic-sized swimming pools, severely depleting fresh water resources. Our breakthrough solution employs agricultural waste by transforming rice husks into phase change materials. Combined with AI-optimized geothermal loops, our closed-loop system reduces water usage by 80% and energy requirements by nearly 50%, making sustainability cool and practical indeed.',
      },
      {
        name: 'Formosa101',
        school: 'Labi Education',
        country: 'Taiwan',
        photo: '/images/scholars2025/formosa101.webp',
        description:
          'NanoHance revolutionizes agriculture in face of climate change with a cost-effective solution: a genetic modular platform utilizing nanoparticles to infuse crops with tailored resilience genes. By delivering proteins like HSP70 (heat tolerance), OtsA/OtsB (cold resistance), and PR2 (disease defense), this system fortifies plants at a molecular level, combating extreme weather threats and surpassing expensive and unsustainable methods like greenhouse cultivation. Our approach is scalable, accessible, and eco-friendly, eliminating reliance on costly infrastructure. This innovation redefines climate adaptation, empowering food systems worldwide, democratizing advanced agricultural technology, and revolutionizing crop protection against environmental extremes.',
      },
      {
        name: 'GreytoGrow',
        school: 'Jamnabai Narsee International School',
        country: 'India',
        photo: '/images/scholars2025/greytogrow.webp',
        description:
          'The low-income communities in my locality have limited access to water and face challenges due to inefficient greywater management. Approximately 80% of the water produced by a household of four flows into untreated water bodies. This is exacerbated by the polluted water discarded by large factories, such as textile firms, resulting in unsanitary conditions and mosquito breeding grounds. To transform this system and repurpose the water that would otherwise be wasted, I implemented a three-step process that mimics the plants and animals in a natural wetland ecosystem, allowing greywater to be filtered and made suitable for use in non-potable applications.',
      },
      {
        name: 'Neer-Rakshak',
        school: 'Delhi Public School R. K. Puram',
        country: 'India',
        photo: '/images/scholars2025/neer.webp',
        description:
          'As cities worldwide struggle with water scarcity, I aim to tackle this challenge through responsible consumption while reducing carbon emissions from freshwater supply and centralized sewage treatment. Bilge Vessel and Scupper Valve are two indigenous, smart comrade in arms that collect, treat, and reuse greywater at the source without requiring any modifications to the current home plumbing network. By bridging the gap between theoretical knowledge and practical application, this solution positively impacts the urban water cycle, consuming 80% less electricity than city-level treatment, reducing the strain on municipalities and empowering homes to save and fight the water crisis.',
      },
      {
        name: 'ThermaVault',
        school: 'The Shishukunj International School Indore',
        country: 'India',
        photo: '/images/scholars2025/thermavault.webp',
        description:
          "Our team was formed with a vision of sustainable design and a common love for Beyblades. The COVID pandemic served as a reminder of the lack of electricity availability in rural areas; we've seen, firsthand, the problems with transporting vaccines, food and essential supplies to these locations. Thus, we redesigned our science-fair cooling system into our solution. ThermaVault uses salt-based endothermic reactions (which are reusable and sustainable) to create an electricity-free refrigeration unit. This solves a trifecta of problems: plastic waste through thermocol, energy inequality, and inefficient cooling, especially for vaccines. Learn more about us at www.thermavault.us",
      },
    ],
  },
  {
    name: 'Middle East',
    teams: [
      {
        name: 'Aqua Care',
        school: 'Qatar Science and Technology Secondary School for Boys',
        country: 'Qatar',
        photo: '/images/scholars2025/aquacare.webp',
        description:
          'AquaCare is a breakthrough solution leveraging AI and IoT to monitor water quality in real-time, ensuring safe drinking water. Our system continuously measures critical parameters such as pH, turbidity, temperature, and TDS, providing instant alerts and actionable insights. Our team—QSTSS AquaGuardians, comprising Jassim Al-Shamri and Omar Alemadi, mentored by           \tMr.  Ahmed Hammoudeh—has been recognized for excellence in innovation. We are passionate about addressing water safety challenges, promoting sustainability, and aligning with UN SDGs. Our fresh idea revolutionizes water monitoring for households, small communities, and public institutions.',
      },
      {
        name: 'Skyinnovators',
        school: 'WTEC High School',
        country: 'Lebanon',
        photo: '/images/scholars2025/skyinnovators.webp',
        description:
          'We are the “Skyinnovators” from the WTEC High School. From a small village (Rashaya Alwadi- Lebanon), we participate in The Earth Prize with great passion, and intention to be a part of the solution, not part of the climate pollution.\n' +
          '\n' +
          'The air on which all life depends, has become global garbage can, so reducing air pollution is equivalent to saving many lives. Our product is an affordable, efficient air filter composed of zeolite, rice husk, charcoal, and bamboo, into pole with solar-powered screens for advertising and IoT-based air quality monitoring and offers a return on investments that encourage municipalities to adopt it.',
      },
      {
        name: 'Sustainability Heroes',
        school: 'Ghayathi School Common',
        country: 'United Arab Emirates',
        photo: '/images/scholars2025/sustainability.webp',
        description:
          'We’re the Sustainability Heroes, five passionate students, guided by our gracious mentor, Hanan Gamal, on a mission to revolutionize recycling education. With EcoMind Academy, we’re not just teaching sustainability.. we’re refining it!\n' +
          '\n' +
          'Our journey began with a question: If AI can power the future, why not use it to save the planet? EcoMind Academy is an AI-driven platform that makes recycling education interactive, personalized, and action-driven. Through gamified challenges, virtual assistants, and real-world applications, we empower students to become changemakers. Our vision? A world where knowledge isn’t just learned.. it’s lived, shaping a greener tomorrow, one mind at a time.',
      },
      {
        name: 'Sustolia',
        school: 'Eskişehir Fatih Science High School',
        country: 'Turkey',
        photo: '/images/scholars2025/sustolia.webp',
        description:
          'Our project tackles the issue of wastewater pollution caused by high treatment costs, leading industries to release untreated water into nature, harming both the environment and human health. To address this, our team has developed a hybrid Advanced Oxidation Process (AOP) system that combines plasma and photocatalysts to efficiently break down toxic pollutants. Unlike conventional AOP methods, this system reduces costs and energy consumption, making it a viable alternative for businesses. It can treat even highly contaminated wastewater, ensuring that discharged water is safe for the environment, with potential for reuse in the future—all without relying on chemicals or biological agents.',
      },
      {
        name: 'The Chill Krill',
        school: "St Christopher's School",
        country: 'Bahrain',
        photo: '/images/scholars2025/krill.webp',
        description:
          "Aritro Ghosh, a 15-year-old science stream student at St Christopher's School primarily interested in pursuing marine biology in the future.\n" +
          '\n' +
          'Under-ice Krill Nurseries offer a practical solution to declining krill populations in polar regions. Our design consists of simple feeding stations that attach beneath sea ice, releasing iron-enriched nutrients to stimulate plankton growth in targeted areas. This creates reliable feeding zones for juvenile krill during their critical development phase. Each station combines marine-grade materials with basic nutrient delivery systems, making them both durable and cost-effective. By supporting krill during their most vulnerable life stage, these nurseries help maintain population stability while advancing our understanding of polar marine ecosystems through integrated monitoring capabilities.',
      },
    ],
  },
  {
    name: 'Africa',
    teams: [
      {
        name: 'AquaGuard Innovators',
        school: 'Sharkya STEM School',
        country: 'Egypt',
        photo: '/images/scholars2025/aquaguard.webp',
        description:
          'Our project addresses the critical issue of microplastic pollution in water, posing significant environmental and public health risks. We aim to develop an innovative saw device that captures microplastic particles using acoustic force, made from affordable materials, reducing costs by 95%. This device boasts an efficiency of 93%. Additionally, we integrated an AI detection tool (Yolov8) and have trained a machine learning model with datasets of microplastics under various conditions. By incorporating the DeepSORT algorithm, we enhance tracking efficiency to between 90-95%. This solution offers a cost-effective and highly efficient approach to tackling water pollution.',
      },
      {
        name: 'Earth for Heart',
        school: 'Gateway High School',
        country: 'Zimbabwe',
        description:
          'The global water crisis claims 3.4 million lives annually, with over 2 billion people lacking access to safe drinking water. Current solutions are often ineffective, costly, or unsustainable, leaving vulnerable communities at risk. Our team has developed a cutting-edge, low-cost, and scalable water filtration system that could redefine access to clean water worldwide.\n' +
          'Our xylem-activated carbon filtration device, engineered using bio-enhanced orange peels and clay-based illite, removes over 99% of contaminants, including biological and chemical pollutants. Designed for household use, it provides over 40 litres of purified water per day, meeting the daily needs of a family. Unlike conventional filters, it is affordable, sustainable, and easily replicable, ensuring long-term usability in low-resource settings.',
        photo: '/images/scholars2025/earthforheart.webp',
      },
      {
        name: "Let's Conserve",
        school: "Tariq's Homeschool",
        country: 'Nigeria',
        photo: '/images/scholars2025/letsConserve.webp',
        description:
          "Tariq Lawal believes that collective action is necessary to tackle the triple planetary crisis, which is why he wants to make Let's Conserve a reality. Let's Conserve is an app that will unite individuals, communities, and organizations in a collective effort to combat climate change, biodiversity loss, and pollution. Through engaging features like environmental challenges, educational resources, gamified tasks, community forums, and a digital space for sharing sustainable practices, the app will empower users to make a tangible impact. By fostering collaboration, Let's Conserve could create a global movement where every small action contributes to meaningful change.",
      },
      {
        name: 'Preserve Our Roots',
        school: 'Greensprings School Lekki',
        country: 'Nigeria',
        photo: '/images/scholars2025/preserve.webp',
        description:
          "Amara C. Nwuneli is a 17-year-old Nigerian-American activist, social innovator, author, and performing artist passionate about climate action, youth empowerment, and climate storytelling. She is the founder of Preserve Our Roots, a by-youth, for-youth NGO and social activism movement that serves as an incubation hub for youth action through climate education campaigns, grassroots initiatives, and direct policy engagement. Preserve Our Root's GREEN initiative is a transformative sustainability park built from recycled materials, combining experiential learning, climate storytelling, and community empowerment to inspire a greener Lagos and give nature back to its millions. It is an oasis where individuals can reconnect with nature, foster community, and learn about sustainability. By weaving narratives of resilience and empowerment into a reclaimed land fill site, GREEN encourages individuals to believe that their actions matter, pushes for a global shift towards #SustainableUrbanLiving, and inspires a network of eco-conscious youth leaders.",
      },
      {
        name: 'WASTE TO CLEAN ENERGY',
        school: 'Egba Odeda High School Junior / Teach For Nigeria',
        country: 'Nigeria',
        photo: '/images/scholars2025/wasteToClean.webp',
        description:
          'Our team, led by Ebenezer Anyadiegwu, is passionate about clean energy and sustainability. Through our Sparkwise Initiative, we developed a Household Appliances Innovation Powered by Solar and Biogas Energy Solutions. This project repurposes discarded plastic and electronic waste to create solar-powered household appliances and biogas energy systems for clean cooking. Our initiative reduces e-waste pollution, promotes renewable energy adoption, and empowers students with STEM and environmental problem-solving skills. We aim to scale this innovation to reach more schools and communities across Africa, fostering a future where sustainable energy solutions are accessible to all.',
      },
    ],
  },
  {
    name: 'Europe',
    teams: [
      {
        name: 'AquaSight',
        school: 'Westminster School',
        country: 'United Kingdom',
        photo: '/images/scholars2025/aquasight.webp',
        description:
          'Our team, composed of aspiring engineers, space physicists, and economists who all study A-level physics at Westminster School, is driven by firsthand experiences with water quality issues. As open-water swimmers, environmental conservationists, and litter pickers, we are determined to tackle water pollution, ensuring a cleaner River Thames, a healthier environment, and a brighter future for all.',
      },
      {
        name: 'CynoFilter',
        school: 'Eton College',
        country: 'United Kingdom',
        photo: '/images/scholars2025/cynofilter.webp',
        description:
          'Our mission is to provide a natural solution to the climate crisis. With immense time and investment being funnelled into methods that do not yield worthy results or damage the environment in the process, we propose a far greater alternative.\n\n' +
          'The CynoFilter is a biological filter that utilises cyanobacteria encased in a sodium alginate matrix. This cheap and highly simplistic form of carbon capture is based on a layered honeycomb design and a system of membranes and filters to enhance durability, efficiency, and set us apart from anything else on the market.',
      },
      {
        name: 'MP3D',
        school: 'Winchester College',
        country: 'United Kingdom',
        photo: '/images/scholars2025/mp3d.webp',
        description:
          'MP3D disrupts microplastic pollution through prevention, not cleanup. \n' +
          ' \n' +
          'Our open-source solution, presented at the European Conference on Artificial Intelligence, uses a novel 3D machine learning algorithm (94.6% classification accuracy) to analyse particles’ volume, polymer type, and ecological impact.\n' +
          ' \n' +
          'Costing under 50 USD, it empowers coastal communities in developing countries to halt pollution at its source. By generating real-time data on origins and potential toxicity, MP3D equips regulators with actionable evidence, replacing sporadic inspections with automated accountability. \n' +
          ' \n' +
          'This precision enables targeted policies, preserving ecosystems and economies by curbing discharge before irreversible harm.',
      },
      {
        name: 'PURA',
        school: 'Gymnázium Jura Hronca & Gymnázium Hradec Králové',
        country: 'Slovakia & Czechia',
        photo: '/images/scholars2025/pura.webp',
        description:
          "We as the PURA duo are driven by the urgent global threat of antibiotic resistance and water pollution. We decided to address this by joining Anna's research purifying water using photocatalysis and Tomas's work destroying water pollutants and bacteria with cold plasma called AC corona. By developing this integrative and innovative technology, we aim to mitigate public health risks, preserve ecosystems, and slow biodiversity loss, while reducing costs, toxic byproducts, and greenhouse gas emissions for a sustainable future.",
      },
      {
        name: 'PureDae',
        school: 'The Academy International School',
        country: 'Spain',
        photo: '/images/scholars2025/puredae.webp',
        description:
          "Livestock contributes to over 25% of global greenhouse gas (GHG) emissions, affecting air quality and sanitation inside barns. This increases the animals' mortality rate, affects workers' health, and has recently imposed a financial burden on the industry due to carbon taxes.\n\n" +
          "As the effects of climate change become more evident, the need for innovations that reduce the livestock industry's GHG emissions rapidly increases. That’s why PureDae, an affordable air filtration unit designed for barns, emerged as a game-changing solution. Our technology filters out carbon dioxide, ammonia, and VOCs, collecting pure methane to be used as a renewable energy source.",
      },
    ],
  },
  {
    name: 'Central & South America',
    teams: [
      {
        name: 'EcoAction',
        school:
          'Instituto Federal de Educação, Ciência e Tecnologia do Tocantins - Campus Palmas',
        country: 'Brazil',
        photo: '/images/scholars2025/ecoaction.webp',
        description:
          'Isaque Carvalho Borges is a high school student passionate about sustainability, AI, and social impact. He is the founder and manager of Palmas EcoAção and the EcoAction Team. This project leverages AI and satellite imagery to revolutionize urban climate resilience. By pinpointing the most strategic locations for vegetation to mitigate extreme heat, it empowers local organizations to cool cities efficiently with minimal effort and maximum impact. The AI analyzes urbanization patterns—past and present—while predicting key areas for future heat island formation. This enables targeted green interventions that reduce heat, purify air, and enhance livability. Backed by Naturatins, IFTO, and local stakeholders, the project turns data into action, transforming sustainability from theory into tangible urban solutions.',
      },
      {
        name: 'Madre Tierra',
        school: 'Colegio de Alto Rendimiento San Martín',
        country: 'Peru',
        photo: '/images/scholars2025/madre.webp',
        description:
          'As a Madre Tierra group, we have proposed the product ‘Yaku Sumaq’, which is based on the use of recycled clothing to make resistant sacks that contain the hydrophobic particles necessary for the effective adsorption of oil in water bodies, as an alternative to mitigate the impact of oil in these ecosystems. In addition, the materials used to make the product can also provide a solution to several of the current environmental problems, such as pollution from textile waste and rice husk residues.',
      },
      {
        name: 'TEKOHÁ',
        school: 'Colégio São José',
        country: 'Brazil',
        photo: '/images/scholars2025/tekoha.webp',
        description:
          'Tekohá is an innovative initiative that uses technology to map and combat climate injustice in Brazil. The name “Tekohá,” from the Guarani language, represents the deep bond between communities and their land, emphasizing resistance, collective action, and environmental preservation.  \n' +
          '\n' +
          'Gianna, Lara, Sofia, Nicolas, and Giovanna, experiencing different facets of climate change, united for a common cause: creating Brazil’s largest climate injustice platform. By centralizing data and amplifying marginalized voices, Tekohá bridges communities and solutions, empowering municipalities to develop data-driven, inclusive policies. This initiative ensures those most affected by climate change have a voice in shaping effective, equitable environmental action.',
      },
      {
        name: 'The Forest Watchman',
        school: 'Sociedad de Jóvenes y Niñas Científicas',
        country: 'Colombia',
        photo: '/images/scholars2025/watchman.webp',
        description:
          'Isabella Cabrera, a high school student in Yumbo, is dedicated to protecting the biodiversity of her community. With the guidance of Nelly Cantillo, a professor at the Universidad del Rosario, this team developed Vigía Forestal, a project that uses autonomous drones with artificial intelligence to detect fires in real time. The AI analyzes the flora, fauna, flammable vegetation and nearby homes to anticipate the evolution of the fire and optimize the response. In addition, the drones can deploy ammonium carbonate bombs, mitigating fires without damaging the ecosystem. In this way, Vigía Forestal strengthens the response to environmental emergencies in Yumbo.',
      },
      {
        name: 'UEGEA',
        school: 'Unidad Educativa General Eloy Alfaro – Salcedo',
        country: 'Ecuador',
        photo: '/images/scholars2025/uegea.webp',
        description:
          'Wildfires devastate millions of hectares yearly, leaving infertile soil and disrupted ecosystems. The loss of microbial diversity slows recovery, increasing erosion, desertification, and food insecurity.\n\n' +
          'Introducing UEGEA Team’s mountain microorganism technology, a nature-based solution that accelerates post-fire soil regeneration. By restoring microbial life, this method enhances soil fertility, improves water retention, and promotes plant regrowth, transforming degraded land into thriving ecosystems.\n\n' +
          'With its low-cost, scalable, and science-driven approach, this solution provides a sustainable path to recovery. Inspired by The Earth Prize, we are committed to expanding this method and empowering communities to heal their environment.',
      },
    ],
  },
  {
    name: 'North America',
    teams: [
      {
        name: 'Aeifloria',
        school: 'The Knowledge Society',
        country: 'Canada',
        photo: '/images/scholars2025/aeifloria.webp',
        description:
          'Animal-based pollination supports 35% of global food production, and more than 80% of all fruit and vegetables supply, yet 1 in 4 bees are at risk of extinction globally. This happens largely due to climate stress, which reduces the production of floral scents and degrades floral resources such as nectar and pollen. Aeifloria is a 3D-printed flower that mimics the sweet-smelling scents that nectar-rich flowers once produced, aiming to guide bees back to nectar hotspots. By increasing a plant’s floral scent, even in a synthetic way, we initiate a positive self-reinforcing cycle of bee-flower interaction.',
      },
      {
        name: 'A Sustainable Future',
        school: 'Bellevue High School',
        country: 'United States',
        photo: '/images/scholars2025/asf.webp',
        description:
          'We are Dhruv, Tara, and Carolyn, from A Sustainable Future. Our mission is to reduce paper consumption in schools and empower students to combat this issue. So, we created the Paper Consumption Model, which allows schools to input printing data and instantly receive details about expected cost, trends over time, and recommendations to reduce consumption. We have also created the Paper Consumption Program for students, which includes pages of lessons and simulations covering topics like paper consumption, sustainability practices, and real-world advocacy. Together, these create a practical, engaging solution for schools to adopt sustainable practices and foster environmental awareness.',
      },
      {
        name: 'EcoHikes',
        school: 'Horace Mann School',
        country: 'United States',
        photo: '/images/scholars2025/ecohikes.webp',
        description:
          'EcoHikes is a fun and educational initiative designed to introduce children to the wonders of nature while teaching them the importance of environmental conservation. Through engaging hikes and interactive activities, EcoHikes encourages young explorers to discover local ecosystems, learn about wildlife, and understand the impact of climate change. The program fosters a sense of responsibility and love for the planet, empowering children to become eco-conscious stewards of the future. With hands-on experiences and a focus on sustainability, EcoHikes aims to inspire the next generation to appreciate and protect the natural world.',
      },
      {
        name: 'HARVEST',
        school: 'La Jolla High School',
        country: 'United States',
        photo: '/images/scholars2025/harvest.webp',
        description:
          'High-Alert Remote Visual Environmental Soil Tracker. HARVEST transforms traditional farming using innovative artificial intelligence and drone technology to deliver a smarter, greener way to manage irrigation. Drones survey agricultural fields, gathering real-time data on soil and crops, while AI predicts areas requiring irrigation, allowing farmers to determine water-deficient crop areas. With HARVEST, farmers gain a powerful tool to reduce waste, conserve resources, and boost crop yields—all contributing to sustainable farming and food security around the world.',
      },
      {
        name: 'StuyBigCompGroup',
        school: 'Stuyvesant High School',
        country: 'United States',
        photo: '/images/scholars2025/stuy.webp',
        description:
          'Kiriboard is an innovative, eco-friendly packaging solution designed to reduce plastic waste while maintaining high product protection. Utilizing kirigami-inspired geometric folding, Kiriboard folds out from a portable sheet of cardboard to form a shock-absorbing structure, eliminating the need for plastic-based fillers like styrofoam. Made entirely from recycled cardboard, Kiriboard’s lightweight design enables drastically lowered shipping emissions, making it a competitive sustainable alternative to conventional packaging materials. Scalable for mass production by using CNC scoring or laser-cutting, Kiriboard is poised to revolutionize the shipping industry by offering a cost-effective, biodegradable, and structurally superior packaging solution for E-commerce and logistics.',
      },
    ],
  },
];

export const SCHOLARS2024 = [
  {
    name: 'Coagulation',
    country: 'India',
    school: 'Adarsh Vidya Kendra School',
    photo: '/images/scholars2024/adarsh.webp',
    team: '/images/scholars2024/teams/coagulation.webp',
    description: (
      <>
        The detrimental impact of plastics on our environment is undeniable,
        with their non-biodegradable nature causing long-lasting pollution
        across land and marine ecosystems. High-density polyethylene (HDPE)
        covers a significant portion of plastic production and contributes to
        this crisis, with only a fraction being recycled.
        <br />
        <br />
        To combat this, we&apos;ve innovatively repurposed these covers,
        employing efficient recycling techniques and integrating luffa fibers to
        create eco-friendly tiles. Through meticulous research, we&apos;ve
        transformed polyethylene covers into tiles using advanced methods,
        enhancing their mechanical properties and durability. Our findings
        underscore the superior performance of these composite tiles, heralding
        a sustainable solution to the plastic pollution crisis while advancing
        tile technology.
      </>
    ),
  },
  {
    name: 'Green Inc.',
    country: 'Greece',
    school: 'Anatolia College',
    photo: '/images/scholars2024/anatolia.webp',
    team: '/images/scholars2024/teams/greenInc.webp',
    description: (
      <>
        In the wake of escalating wildfires, our planet faces a dire
        environmental crisis, impacting not only forests and communities but
        also vital agricultural lands. The degradation of farmlands leads to
        soil depletion and threatens biodiversity on a global scale. In Greece,
        where wildfires proliferate at an alarming rate, urgent action is
        crucial to prevent further devastation.
        <br />
        <br />
        Introducing our solutions: &quot;Agro Fire Alarm&quot; and &quot;Aqua
        Guardian.&quot; These innovative systems utilize advanced technology to
        detect and combat fires swiftly. From alerting property owners to
        deploying water directly at fire sources, our inventions offer a vital
        lifeline to agro-businesses, NGOs, and governments. With our solutions,
        we aim to protect agricultural resources and promote resilience in the
        face of environmental challenges.
      </>
    ),
  },
  {
    name: 'CatchFish',
    country: 'Vietnam',
    school: 'COMPA STEM',
    photo: '/images/scholars2024/compa.webp',
    team: '/images/scholars2024/teams/catchFish.webp',
    description: (
      <>
        In Vietnam, the proliferation of plastic waste in water poses grave
        risks to public health, with single-use plastics dominating the debris
        in the Saigon River, exacerbated by the surge in consumption during the
        Covid-19 pandemic. Immediate consequences include drainage system
        blockages and flooding, contaminating agricultural water sources and
        land. Moreover, the long-term effects manifest in the generation of
        microplastics, threatening chromosome integrity, inducing cancer, and
        disrupting ecosystems.
        <br />
        <br />
        To address this crisis, we propose a tailored solution: a remotely
        operated underwater vehicle (ROV) garbage collector designed for small
        lakes, rivers, and drains. Equipped with advanced technology, including
        motors for diving up to 6 meters, the ROV performs essential tasks such
        as garbage detection, capture, and collection, offering a sustainable
        approach to tackling plastic pollution in Vietnam&apos;s waterways.
      </>
    ),
  },
  {
    name: 'HiveHealthy',
    country: 'New Zealand',
    school: 'Crimson Global Academy',
    photo: '/images/scholars2024/crimson.webp',
    team: '/images/scholars2024/teams/hiveHealthy.webp',
    description: (
      <>
        Managed pollination plays a pivotal role in global food production,
        sustaining 35% of the food supply and supporting 75% of key crops.
        However, the indispensable honeybee, a primary pollinator, faces
        escalating threats worldwide, with alarming rates of colony collapse,
        notably in America. Varroa mites, pesticide exposure, and climate change
        contribute significantly to this decline, burdening beekeepers and the
        farmers reliant on their pollination services.
        <br />
        <br />
        To combat this crisis, I propose an innovative honeybee hive
        health-monitoring system. Equipped with internal and external cameras
        for visual inspection, alongside sensors monitoring temperature,
        humidity, hive weight, and vibration, this system ensures early
        detection of threats. A mobile app processes live data, utilizing
        machine learning to identify health risks and provide timely alerts,
        empowering beekeepers to safeguard hive health and preserve pollination
        ecosystems.
      </>
    ),
  },
  {
    name: 'TerraSense',
    country: 'United States',
    school: 'Crystal Springs Uplands School',
    photo: '/images/scholars2024/crystal.webp',
    team: '/images/scholars2024/teams/terraSense.webp',
    description: (
      <>
        Droughts wreak havoc on crops, forests, and communities, limiting access
        to water and food and intensifying ecoanxiety among youth. Inefficient
        irrigation systems exacerbate water loss, with households and farms
        squandering thousands of gallons annually.
        <br />
        <br />
        To address this crisis, TerraSense introduces highly responsive soil
        moisture sensors to combat water waste and support plant life. Utilizing
        miniaturized electronic detection, TerraSense provides real-time
        feedback on soil moisture levels, preventing overwatering and promoting
        sustainability. A thin electronic circuit board inserted into the soil
        detects moisture levels, with an LED indicator signaling the optimal
        watering conditions. Affordable, portable, and user-friendly, TerraSense
        empowers individuals worldwide to conserve water resources and build
        resilient ecosystems, fostering both environmental and psychological
        well-being.
      </>
    ),
  },
  {
    name: 'Ceres',
    country: 'Türkiye',
    school: 'Bahçeşehir Koleji Diyarbakir',
    photo: '/images/scholars2024/bahcesehir.webp',
    team: '/images/scholars2024/teams/ceres.webp',
    description: (
      <>
        In modern-day Mesopotamia, once a fertile haven between the Tigris and
        Euphrates rivers, we grapple with a pressing environmental crisis: crop
        loss induced by shifting climates, drought, and pollution. Just two
        years ago, our region faced an unprecedented drought, resulting in an
        alarming 80% decrease in crop production due to a 40% decline in
        precipitation rates. This local plight mirrors a global challenge,
        triggering economic turmoil and food scarcity in communities worldwide.
        <br />
        <br />
        Our proposed solution harnesses the power of plasma, the fourth state of
        matter, to combat biotic and abiotic stressors on plants and boost crop
        yield. Through direct plasma treatment, seeds are exposed to charged
        particles and reactive species, enhancing germination and growth.
        Indirect treatment enriches irrigation water, transforming its
        properties to support plant health and reproduction. This innovative
        approach not only mitigates crop loss but also reduces reliance on
        chemical fertilizers, offering a sustainable and cost-effective solution
        for farmers globally.
      </>
    ),
  },
  {
    name: 'DIELECTRİC',
    country: 'Türkiye',
    school: 'Eskişehir Fatih Fen Lisesi',
    photo: '/images/scholars2024/eskisehir.webp',
    team: '',
    description: (
      <>
        In Turkey, the world&apos;s leading consumer of tea, the staggering
        volume of tea waste, totaling thousands of tons annually, poses a
        significant environmental challenge. While a portion is repurposed as
        fertilizer, a substantial amount is needlessly discarded, representing a
        considerable loss.
        <br />
        <br />
        To address this issue, we, passionate tea enthusiasts, have devised an
        innovative solution: converting tea waste into activated carbon for use
        in supercapacitors, the future&apos;s energy storage systems. Through
        meticulous research, we&apos;ve unlocked the potential of tea waste as a
        versatile material, suitable for applications in water purification and
        skincare. By incorporating it into eco-friendly and recyclable
        supercapacitors, we not only mitigate waste but also combat the
        environmental impact of conventional batteries. With superior energy
        transfer capabilities, our solution paves the way for sustainable energy
        storage solutions.
      </>
    ),
  },
  {
    name: 'Mycoflo',
    country: 'United Kingdom',
    school: 'Eton College',
    photo: '/images/scholars2024/eton.webp',
    team: '/images/scholars2024/teams/mycoflo.webp',
    description: (
      <>
        Water, vital to communities worldwide, faces dire pollution in the Niger
        Basin due to burgeoning agriculture and industry, endangering one
        million lives. Crude oil extraction and mineral mining contribute heavy
        metals, poisoning water sources and threatening ecosystems and human
        health. Unfortunately, current water quality diagnosis and filtration
        methods are inaccessible to the most affected areas.
        <br />
        <br />
        To address this crisis, we introduce Mycofiltration - a revolutionary
        solution utilizing fungi to filter water. Our invention, MycoSacks,
        composed of native Pleurotus tuber-regium spores and organic materials,
        effectively removes pollutants. Accompanied by a diagnostic framework
        and automated robot, MycoBot, equipped with AI, our solution provides
        efficient and cost-effective water filtration, ensuring safe drinking
        water for communities in need. With &gt;60% concentration reduction
        observed in testing, Mycofiltration offers hope for cleaner water and
        healthier lives in the Niger Delta.
      </>
    ),
  },
  {
    name: 'Pebble',
    country: 'United Kingdom',
    school: 'Eton College',
    photo: '/images/scholars2024/eton.webp',
    team: '/images/scholars2024/teams/pebble.webp',
    description: (
      <>
        Globally, over 120 million consumer graphics cards (GPUs) lay idle,
        despite their high carbon footprint in manufacturing and rare earth
        element content. This inefficiency contributes to excessive energy
        consumption, equivalent to powering 811,000 average USA homes for a
        year. Furthermore, the machine learning field, heavily reliant on GPUs,
        overlooks environmental considerations, with AI training emitting carbon
        emissions equivalent to driving 123 cars for a year.
        <br />
        <br />
        Our solution addresses these challenges by pooling these underutilized
        GPUs into a unified network. Through our platform, contributors rent out
        their computers, optimizing resource usage and democratizing access to
        high-powered computing. This initiative not only maximizes the
        utilization of GPUs, reducing carbon emissions and rare earth metal
        consumption, but also efficiently utilizes idle energy, saving 8.76
        billion kWh annually. By offering computing power at competitive prices,
        we empower innovation and progress while fostering environmental
        sustainability in the tech industry.
      </>
    ),
  },
  {
    name: 'Ingenia Clima',
    country: 'Hong Kong',
    school: 'French International School',
    photo: '/images/scholars2024/lycee.webp',
    team: '/images/scholars2024/teams/ingeniaClima.webp',
    description: (
      <>
        Ghost nets, lost fishing nets adrift in the seas, pose a grave threat to
        marine life, constituting nearly half of the debris in the Great Pacific
        Garbage Patch. These non-biodegradable nets entangle marine wildlife,
        jeopardizing their health and survival. To safeguard our planet&apos;s
        biodiversity, urgent action is essential to prevent further devastation.
        <br />
        <br />
        Our solution addresses this crisis at its root: the production of
        fishing nets. Introducing mycelium fishing nets, a biodegradable
        alternative, we aim to replace nylon nets that take up to 600 years to
        decompose. With a mere 40-day decomposition period, mycelium nets
        drastically reduce the risk of long-term harm to marine ecosystems.
        Moreover, as 100% biodegradable, they curb plastic pollution in our
        oceans and mitigate carbon emissions from plastic production. Strong,
        cost-effective, and environmentally friendly, mycelium nets offer an
        optimal solution to combat the scourge of plastic in our seas.
      </>
    ),
  },
  {
    name: 'EcoFruitFlow',
    country: 'Taiwan',
    school: 'GEMS Academy',
    photo: '/images/scholars2024/gems.webp',
    team: '/images/scholars2024/teams/ecoFruitFlow.webp',
    description: (
      <>
        As global pollution increasingly contaminates water sources with toxic
        metal ions like lead and copper, the need for effective filtration
        solutions becomes paramount. Conventional ion exchange filters
        exacerbate aquatic pollution with microplastic-releasing resins,
        compounding environmental concerns. Meanwhile, fruit peel waste,
        comprising a significant portion of annual fruit waste, remains
        underutilized.
        <br />
        <br />
        To address this challenge, our team developed a fruit peel filter,
        utilizing recycled waste to minimize environmental impact. Combining
        fruit peels with activated carbon and polypropylene cotton, our
        innovative filter effectively removes odor, color, bacteria, and ions
        from water. By repurposing fruit peel waste, we offer a sustainable
        alternative to conventional filtration methods, aligning with climate
        change mitigation efforts. This eco-friendly solution not only maximizes
        filtration efficiency but also reduces waste, providing a dual benefit
        for communities worldwide, particularly in regions with high fruit
        consumption and inadequate water sanitation.
      </>
    ),
  },
  {
    name: 'The Miracle Tree',
    country: 'Lebanon',
    school: 'Greenfield College',
    photo: '/images/scholars2024/greenfield.webp',
    team: '/images/scholars2024/teams/miracle.webp',
    description: (
      <>
        Forest fires, exacerbated by climate change and human activities,
        devastate ecosystems and soil quality, leading to significant
        biodiversity loss. To combat this escalating crisis, we&apos;ve
        developed an innovative solution: the artificial tree. This tree serves
        a dual purpose, fighting fires and ensuring soil health.
        <br />
        <br />
        Equipped with rainwater-harvesting capabilities, the tree utilizes
        stored water to extinguish fires, while its sensor technology detects
        smoke and alerts authorities. Utilizing GIS applications, our tree
        provides real-time incident mapping, aiding in fire response efforts.
        Furthermore, its extensive root system, embedded with pH and moisture
        sensors, monitors soil conditions, replenishing nutrients as needed. By
        addressing both fire prevention and soil quality maintenance, our
        artificial tree offers a comprehensive approach to mitigating the
        devastating impacts of forest fires on biodiversity, ecosystems, and
        climate.
      </>
    ),
  },
  {
    name: 'CocoMellow',
    country: 'Vietnam',
    school: 'i-IVY',
    photo: '/images/scholars2024/ivy.webp',
    team: '/images/scholars2024/teams/cocoMellow.webp',
    description: (
      <>
        Every day, 250 million disposable baby diapers are used globally,
        contributing to a staggering environmental problem. These diapers,
        primarily composed of non-biodegradable synthetic materials, end up in
        landfills, taking centuries to decompose and polluting soil and water
        with microplastics. Meanwhile, eco-friendly alternatives, made from
        organic cotton and bamboo fiber, remain inaccessible to many due to
        their high cost.
        <br />
        <br />
        CocoMellow offers a sustainable and affordable solution by harnessing
        coconut coir and banana fiber, abundant agricultural residues in
        Vietnam. Coconut coir&apos;s exceptional absorbent properties make it
        ideal for the diaper&apos;s core, while banana fiber, with its softness
        and water-resistance, provides comfort and leak protection. By
        repurposing these agricultural by-products, we not only create
        affordable diapers but also promote effective resource utilization,
        addressing both sustainability and accessibility concerns.
      </>
    ),
  },
  {
    name: 'Aquavita',
    country: 'Türkiye',
    school: 'Izmir Bahcesehir Koleji',
    photo: '/images/scholars2024/bahcesehir.webp',
    team: '/images/scholars2024/teams/aquavita.webp',
    description: (
      <>
        Around the globe, approximately 1.8 billion people face the dire reality
        of drinking fecally polluted water, a crisis projected to worsen as
        water pollution and scarcity affect 40% of the population. Recent
        earthquakes have exacerbated this issue, devastating communities in
        Turkey and Syria while increasing heavy metal contamination in water
        sources. To combat this, we&apos;ve innovated a waste-based hydrogel
        capable of adsorbing iron and divalent heavy metal ions from polluted
        water and soil.
        <br />
        <br />
        Our solution harnesses cellulose derived from rosehip and green tea
        waste to create biodegradable hydrogels, effectively purifying water.
        Through rigorous research and testing, we&apos;ve optimized our
        hydrogels to achieve a remarkable 97% efficiency in removing
        contaminants within just 15 to 30 minutes. Coupled with a user-friendly
        stainless steel apparatus, our innovation offers a practical and
        sustainable approach to addressing water pollution crises worldwide.
      </>
    ),
  },
  {
    name: 'KPM',
    country: 'Türkiye',
    school: 'Izmir Bahcesehir Koleji',
    photo: '/images/scholars2024/bahcesehir.webp',
    team: '/images/scholars2024/teams/kpm.webp',
    description: (
      <>
        The beer industry&apos;s heavy water consumption and generation of vast
        amounts of wastewater pose significant environmental challenges,
        particularly in countries like Turkey, where billions of liters of beer
        wastewater are produced annually. Discharging this untreated wastewater
        harms ecosystems and contributes to oxygen depletion in water bodies.
        Additionally, the energy-intensive processes involved in wastewater
        treatment exacerbate the industry&apos;s environmental footprint.
        <br />
        <br />
        To address this issue, our study focuses on harnessing the potential of
        microbial fuel cells (MFCs) to generate electricity from beer wastewater
        and seawater. Unlike conventional fuel cells, MFCs utilize
        microorganisms as catalysts, offering a clean and cost-effective
        approach to electricity generation. By optimizing factors such as
        organic matter content and the performance of electrogenic bacteria,
        MFCs not only provide a sustainable solution for treating beer
        wastewater but also offer potential applications in other organic
        waste-generating industries, further advancing environmental
        sustainability.
      </>
    ),
  },
  {
    name: 'Karaman BİLSEM',
    country: 'Türkiye',
    school: 'Karaman Bilim ve Sanat Merkezi',
    photo: '/images/scholars2024/karaman.webp',
    team: '/images/scholars2024/teams/karaman.webp',
    description: (
      <>
        Global warming, driven by greenhouse gases like methane, poses a
        pressing environmental challenge, with livestock activities contributing
        significantly to methane emissions. Ruminant animals, through enteric
        fermentation, release vast amounts of methane, exacerbating the climate
        crisis.
        <br />
        <br />
        However, solutions lie within innovative feeding strategies. By
        incorporating tannin-rich feeds, derived from sources like black tea,
        into livestock diets, methane emissions can be curbed effectively.
        Tannins, known for their antimicrobial properties, modify rumen
        fermentation, reducing methane production and mitigating environmental
        impact. With global tea production yielding ample tannin resources,
        implementing such feeding practices offers a sustainable approach to
        combat methane emissions, fostering a greener future amidst the climate
        crisis.
      </>
    ),
  },
  {
    name: 'BioAnchor',
    country: 'Hong Kong',
    school: 'Li Po Chun UWC',
    photo: '/images/scholars2024/uwc.webp',
    team: '',
    description: (
      <>
        Intensive commercial farming and deforestation have ravaged soil health,
        depleting nutrients, eroding structure, and diminishing biodiversity.
        <br />
        <br />
        The BioAnchor, a biodegradable 3D printed structure, offers a
        sustainable remedy. Inspired by natural root systems, it fosters plant
        anchorage, nutrient absorption, and moisture retention. As it
        decomposes, it enriches soil, facilitating the return of diverse plant
        communities. Customizable and eco-friendly, the BioAnchor combats
        habitat loss, stabilizes soil, and promotes carbon sequestration. By
        reintroducing native species, it reinvigorates ecosystems, fostering
        long-term biodiversity and resilience in degraded fields. This
        innovative solution heralds a greener future, where agriculture and
        conservation harmonize for sustainable land management.
      </>
    ),
  },
  {
    name: 'Eco-Cran',
    country: 'Canada',
    school: 'Magee Secondary School',
    photo: '/images/scholars2024/magee.webp',
    team: '/images/scholars2024/teams/ecoCran.webp',
    description: (
      <>
        Climate change, fueled by greenhouse gas emissions, poses dire
        consequences like extreme weather and rising sea levels. Livestock,
        particularly cattle, contribute significantly to methane emissions
        through their digestive process.
        <br />
        <br />
        My solution proposes using cranberry by-products in cattle feed to
        mitigate methane production. Cranberry sludge and pomace, abundant from
        juice production, contain tannins known to reduce methane emissions in
        cattle. By incorporating these by-products into feed, we tackle methane
        emissions while repurposing cranberry waste. Additionally, tannins may
        boost milk yield, offering economic benefits to dairy farmers. This
        innovative approach addresses both environmental concerns and
        agricultural efficiency, marking a crucial step in combating climate
        change.
      </>
    ),
  },
  {
    name: 'CodeGreen',
    country: 'Australia',
    school: "Melbourne Girls' College",
    photo: '/images/scholars2024/melbourne.webp',
    team: '/images/scholars2024/teams/codeGreen.webp',
    description: (
      <>
        Climate change disproportionately affects low socioeconomic status (SES)
        communities, yet they often lack representation in climate discussions
        and solutions. With sparse climate education in schools, these
        communities remain further disadvantaged.
        <br />
        <br />
        CodeGreen aims to address this disparity by providing climate and energy
        education to students from low SES backgrounds. Through interactive
        board games, students learn about climate concepts, coding logic, and
        problem-solving skills, empowering them to tackle real-world issues.
        CodeGreen&apos;s workshops, conducted in community centers and
        libraries, offer accessible learning opportunities for students without
        technology access. By expanding to more locations, CodeGreen strives to
        empower students worldwide to become agents of change in creating
        climate-positive solutions.
      </>
    ),
  },
  {
    name: 'Sensory AI',
    country: 'United States',
    school: 'Newport Harbor High School',
    photo: '/images/scholars2024/newport.webp',
    team: '/images/scholars2024/teams/sensoryAI.webp',
    description: (
      <>
        Natural hazards have increased dramatically in recent decades due to
        climate change, industrialization, and population growth, resulting in
        significant human and economic losses worldwide. While early warning
        systems are crucial for minimizing these losses, they are often costly
        and limited to developed nations, leaving many vulnerable communities at
        risk.
        <br />
        <br />
        My proposed solution addresses this gap with an AI-enabled
        mini-meteorological station that requires no existing infrastructure.
        These stations, equipped with a variety of sensors, can detect natural
        hazards and trigger alarms immediately, even in remote areas lacking
        communication infrastructure. By leveraging AI and machine learning
        models, these stations can predict the onset and growth patterns of
        hazards like wildfires, landslides, and oil spills, offering
        cost-effective protection to vulnerable communities worldwide.
      </>
    ),
  },
  {
    name: 'FloodGate',
    country: 'United States',
    school: 'North Carolina School of Science and Mathematics',
    photo: '/images/scholars2024/north.webp',
    team: '/images/scholars2024/teams/floodGate.webp',
    description: (
      <>
        Each year, over 240 million people face the devastating impacts of
        floods, highlighting the critical need for accessible flood prediction
        and detection systems. Vulnerable communities, lacking resources and
        timely information, struggle with evacuation and recovery efforts,
        perpetuating cycles of poverty and socio-economic disparities. Existing
        flood prediction programmes are inadequate, leaving millions of acres of
        land, billions of dollars in property, and thousands of miles of roads
        at risk annually.
        <br />
        <br />
        Introducing FloodGate, a groundbreaking web-based application utilizing
        advanced computational models to predict flood patterns. By harnessing
        geographic elevation data and employing mathematical models, FloodGate
        generates interactive 3D flood models, enabling early prediction of
        flood susceptibility and safeguarding critical infrastructure. With its
        cost-effectiveness and user-friendly interface, FloodGate revolutionizes
        flood prediction, empowering at-risk communities with accessible,
        accurate information to mitigate environmental impacts and ensure
        efficient relief operations.
      </>
    ),
  },
  {
    name: 'Falcons',
    country: 'United States',
    school: 'Palmer Trinity School',
    photo: '/images/scholars2024/palmer.webp',
    team: '/images/scholars2024/teams/falcons.webp',
    description: (
      <>
        Central American countries face the urgent challenge of soil depletion,
        exacerbated by deforestation and harmful farming practices, threatening
        food security, climate resilience, and livelihoods. Chemical fertilizers
        and pesticides worsen soil quality, leading to pollution and high costs
        for farmers already vulnerable to climate change and extreme weather
        events.
        <br />
        <br />
        To address this, our idea is to establish a social enterprise proposing
        a solution rooted in cutting-edge research: highly localized Arbuscular
        Mycorrhizal Fungi (AMF) amendments tailored to Central American soils
        and conditions. Unlike commercially available options limited to a few
        strains and produced abroad, this initiative focuses on region-specific
        strains sourced from tropical forests and prairies. These specialized
        amendments, combined with biochar, enhance soil fertility, promote
        resilient crops, and reduce the need for chemical fertilizers. Moreover,
        profits from the enterprise will empower local communities by investing
        in farmer training and carbon credit initiatives, fostering economic
        diversity and environmental sustainability.
      </>
    ),
  },
  {
    name: 'BrewCrafts Co.',
    country: 'Greece',
    school: 'Psychico College High School',
    photo: '/images/scholars2024/psychico.webp',
    team: '/images/scholars2024/teams/brewCrafts.webp',
    description: (
      <>
        Cereal-based products are vital for nutrition, but climate
        change-induced disasters are threatening grain production worldwide. The
        brewing industry contributes to this issue by generating large amounts
        of Brewers&apos; Spent Grain (BSG), most of which ends up as waste. In
        Greece, the aftermath of Storm Daniel devastated a quarter of the yearly
        grain harvest.
        <br />
        <br />
        To combat this, we launched BrewCrafts, a venture that transforms BSG
        into nutritious flour and other delights. Our products, rich in protein
        and fiber, offer a sustainable alternative to traditional flour-based
        goods. By upcycling BSG and promoting circular economy principles, we
        strive to mitigate the impact of climate change on grain markets while
        offering delicious, eco-friendly options.
      </>
    ),
  },
  {
    name: 'Environmental saviors',
    country: 'Egypt',
    school: 'Sharkya STEM School',
    photo: '/images/scholars2024/sharkya.webp',
    team: '/images/scholars2024/teams/environmentalSaviors.webp',
    description: (
      <>
        Food waste presents a dual challenge: slow decomposition limits organic
        fertilizer production, impacting both manufacturing and agriculture. In
        Egypt, this poses a significant obstacle to soil fertility and crop
        yields.
        <br />
        <br />
        To address this, we&apos;ve developed a project focused on accelerating
        organic waste decomposition to produce high-quality organic fertilizer.
        By leveraging technology, such as an Arduino system controlling
        temperature and moisture, we&apos;ve optimized the decomposition
        process. This solution not only tackles waste management but also offers
        a sustainable alternative to conventional fertilizers, benefiting
        Egyptian agriculture and the economy. Through innovation and technology,
        we aim to revolutionize waste management practices and promote
        environmental sustainability in Egypt.
      </>
    ),
  },
  {
    name: 'Zero emissions pioneers',
    country: 'Egypt',
    school: 'Sharkya STEM School',
    photo: '/images/scholars2024/sharkya.webp',
    team: '/images/scholars2024/teams/zero.webp',
    description: (
      <>
        In Egypt, frequent power outages disrupt daily life, exacerbated by
        increased natural gas consumption and scorching summers. With 90% of
        electricity generated from gas and oil, the country faces a pressing
        need for renewable energy solutions.
        <br />
        <br />
        In response to these challenges, we embarked on a mission to harness
        wind energy for household electricity. Our innovation, the Ducted Lotus
        Wind Turbine, combines the efficiency of the lotus wind turbine with the
        adaptability of the adaptive control ducted compound wind turbine.
        Designed for low-speed conditions and household use, our turbine
        promises high efficiency and reliability. Our goal is to provide
        sustainable energy solutions for homes both locally and globally,
        ensuring a brighter, more reliable future for all.
      </>
    ),
  },
  {
    name: 'PuriOy',
    country: 'Vietnam',
    school: 'Summit Education',
    photo: '/images/scholars2024/summit.webp',
    team: '/images/scholars2024/teams/puri.webp',
    description: (
      <>
        Clean water scarcity affects over 2 billion people globally,
        disproportionately impacting rural communities reliant on contaminated
        groundwater and surface water sources. Existing filtration methods pose
        environmental concerns and are often inaccessible to remote areas.
        <br />
        <br />
        To address this, we propose harnessing waste oyster shells, which have
        demonstrated potential for heavy metal adsorption and organic
        contaminant degradation. By designing a compact filter bead composed of
        powdered oyster shells and biofilms, we offer an affordable and
        eco-friendly solution. This approach not only addresses water
        contamination but also repurposes waste shells, aligning with the needs
        of rural communities. Our campaign aims to provide accessible clean
        water solutions while promoting sustainability and local empowerment.
      </>
    ),
  },
  {
    name: 'Aquamorphosis',
    country: 'Taiwan',
    school: 'Taipei Wego Private Senior High School',
    photo: '/images/scholars2024/taipei.webp',
    team: '/images/scholars2024/teams/aquamorphosis.webp',
    description: (
      <>
        In Taiwan, severe river pollution, mainly from domestic sewage, poses a
        significant threat, with greywater comprising a large portion of
        household wastewater. This greywater, rich in Nitrate, Nitrite, and
        Phosphate from detergents, fuels eutrophication and algae blooms.
        Despite progress in sewage systems, only 42% penetration has been
        achieved, leaving a pressing need for individual greywater treatment
        solutions.
        <br />
        <br />
        Our proposal introduces a home-based wetland plant filtration system,
        strategically installed to target kitchen and laundry greywater sources.
        By decomposing pollutants at the source, this innovative filter offers a
        direct and efficient approach to mitigating eutrophication. Tailored
        adjustments ensure optimal performance, addressing specific pollutants
        present in different greywater sources. This solution not only tackles
        pollution but also promotes sustainable water management practices at
        the household level.
      </>
    ),
  },
  {
    name: 'BioTex',
    country: 'Canada',
    school: 'The Knowledge Society',
    photo: '/images/scholars2024/tks.webp',
    team: '/images/scholars2024/teams/bioTex.webp',
    description: (
      <>
        In Kenya, the staggering daily accumulation of 150-200 tonnes of textile
        waste, predominantly congregated in the vast Dandora Landfill, paints a
        grim picture of environmental mismanagement. However, the intertwined
        economic reliance on second-hand clothing resale complicates waste
        management efforts. Geopolitical tensions hinder governmental action,
        leaving a critical need for innovative solutions.
        <br />
        <br />
        Recognizing this challenge, our team embarked on a journey to address
        both waste accumulation and socioeconomic sustainability. Inspired by
        Germany&apos;s bottle recycling system, we devised a plan to incentivize
        textile recycling by compensating collectors based on the amount of
        cotton waste they gather. Leveraging enzymatic cotton recycling
        technology developed during a hackathon, we convert cellulose into
        glucose, a valuable feedstock for biofuels, generating revenue to
        sustain our initiative while empowering local communities. Through a
        dedicated app, we streamline waste collection efforts, fostering a
        circular economy that tackles waste while supporting livelihoods.
      </>
    ),
  },
  {
    name: 'Terra',
    country: 'Canada',
    school: 'The Knowledge Society',
    photo: '/images/scholars2024/tks.webp',
    team: '/images/scholars2024/teams/terra.webp',
    description: (
      <>
        Soil-borne diseases, a grave concern fueled by bacteria and fungi in
        contaminated soil, pose dire threats to global health and food security.
        With 24% of the world&apos;s population falling prey to illnesses like
        tetanus and salmonella transmitted through infected crops, urgent action
        is imperative.
        <br />
        <br />
        Enter Terra, pioneering precision farming with cutting-edge drones armed
        with hyperspectral sensors and AI-driven algorithms. These drones
        meticulously assess soil quality, detecting pathogens and nutrient
        imbalances, crucial for early intervention and sustainable agriculture.
        By equipping farmers with real-time data and actionable insights, Terra
        empowers them to mitigate disease spread, minimize chemical usage, and
        optimize crop yields. With Terra&apos;s innovative solutions, we pave
        the way towards healthier soils, safer food, and a more sustainable
        future.
      </>
    ),
  },
  {
    name: 'PrithvIQ',
    country: 'India',
    school: 'Trivandrum International School',
    photo: '/images/scholars2024/trins.webp',
    team: '/images/scholars2024/teams/prithvIQ.webp',
    description: (
      <>
        India&apos;s agricultural capacity is hindered by the widespread
        reluctance to adopt sustainable farming practices, with less than 5% of
        farmers embracing change. This not only jeopardizes national food
        security but also raises global concerns over declining nutritional
        quality and environmental degradation.
        <br />
        <br />
        To address this pressing issue, I propose an innovative solution: a
        specialized information system driven by artificial intelligence. This
        system empowers farmers to collect and share real-time farming data via
        a user-friendly smartphone app. By incentivizing data input with
        rewards, we encourage widespread participation, paving the way for
        citizen science research in sustainable agronomy. Through collaboration
        with NGOs like &quot;Bhumi,&quot; we ensure transparency and foster a
        culture of data-driven farming for a greener, more resilient future.
      </>
    ),
  },
  {
    name: 'No-Waste Warmth',
    country: 'Eswatini',
    school: 'Waterford Kamhlaba UWC',
    photo: '/images/scholars2024/wkuwc.webp',
    team: '/images/scholars2024/teams/noWaste.webp',
    description: (
      <>
        South Africa grapples with a plastic waste crisis, ranking among the
        world&apos;s top offenders with 41kg of plastic waste per person
        annually. Limited access to recycling facilities exacerbates the
        problem, especially for township residents facing overflowing landfills
        and environmental health risks.
        <br />
        <br />
        Inspired by sustainable practices at Guba Permaculture Farm, we devised
        a circular solution: waterproof rescue sleeping bags crafted from fused
        crisp packets and recycled plastic bottles. These bags not only
        repurpose discarded materials but also offer immediate aid in the face
        of escalating climate-related disasters. With natural disasters
        projected to surge by 37% by 2025, our initiative aims to provide
        affordable relief while tackling the root cause of environmental
        degradation.
      </>
    ),
  },
  {
    name: 'Cosmic Shawl',
    country: 'United Kingdom',
    school: 'Westminster School',
    photo: '/images/scholars2024/westminster.webp',
    team: '/images/scholars2024/teams/cosmicShawl.webp',
    description: (
      <>
        Tyre wear pollution (TWP) presents a significant environmental
        challenge, contributing heavily to road particulate emissions and
        microplastic contamination in oceans. This pollution not only affects
        urban dwellers but also threatens aquatic ecosystems and air quality.
        <br />
        <br />
        To address this issue, we propose a multifunctional piezoelectric system
        to tackle two main contributors to TWP: flat tyres and driving styles.
        By integrating precise pressure sensing and electricity generation, this
        system raises awareness among drivers about tyre conditions and their
        impact on pollution levels. Through AI algorithms and digital guidance,
        drivers are incentivized to adopt sustainable driving practices,
        reducing both fuel consumption and TWP emissions. Additionally, the
        system&apos;s self-sustainability ensures continuous operation, making
        it a viable solution for mitigating TWP.
      </>
    ),
  },
  {
    name: 'AgroSense',
    country: 'United States',
    school: 'Mason High School',
    photo: '/images/scholars2024/mason.webp',
    team: '/images/scholars2024/teams/agroSense.webp',
    description: (
      <>
        Crop loss during production and harvest stages poses a significant
        challenge, accounting for 20% of global crop losses annually and
        exacerbating world hunger affecting millions. Early detection of crop
        diseases is vital to curbing these losses, yet existing systems are
        inefficient and time-consuming.
        <br />
        <br />
        Enter AgroSense, a revolutionary solution employing UAVs equipped with a
        cutting-edge multimodal neural network powered by AI. This innovative
        system swiftly identifies crop diseases, enabling prompt preventive
        measures to save crops and prevent disease spread. AgroSense&apos;s
        dynamic hyperparameter selection ensures adaptability and accuracy, with
        a target of 85% or higher detection accuracy within 20 seconds. By
        combining technology and agriculture, AgroSense aims to revolutionize
        crop disease detection and mitigate global food insecurity.
      </>
    ),
  },
  {
    name: 'Biobox',
    country: 'United Kingdom',
    school: 'Winchester College',
    photo: '/images/scholars2024/winchester.webp',
    team: '/images/scholars2024/teams/biobox.webp',
    description: (
      <>
        Freshwater ecosystems, critical for biodiversity and human livelihoods,
        face alarming degradation due to climate change, pollution, and
        agricultural waste. Despite their importance, there&apos;s a glaring
        lack of biodiversity data.
        <br />
        <br />
        Faced with this challenge, our team wishes to propose the biobox: an
        innovative solution set to democratize biodiversity data collection.
        Compact and cost-effective, the biobox utilizes cutting-edge technology
        to measure key water parameters and employs machine learning to identify
        organisms and classify microplastics. By monitoring bioindicators and
        analyzing microplastics, the biobox provides valuable insights into
        water health and pollution sources. With plans to share data openly, the
        biobox empowers researchers and policymakers to make informed decisions,
        ensuring the preservation of precious freshwater ecosystems for future
        generations.
      </>
    ),
  },
  {
    name: 'Galactic Einsteins',
    country: 'South Africa',
    school: 'Zwelethemba High School',
    photo: '/images/scholars2024/zh.webp',
    team: '/images/scholars2024/teams/galacticEinsteins.webp',
    description: (
      <>
        In South Africa, millions residing in informal settlements lack proper
        infrastructure, resorting to risky, illegal power trading for
        electricity. Exposed wires pose threats to health, safety, and the
        environment.
        <br />
        <br />
        To address this, our team proposes an energy management system, aiming
        to distribute, control, and monitor energy consumption in marginalized
        communities. This solution not only benefits users economically but also
        aids utilities in reducing blackouts and system overloads while
        fostering safer, cleaner, and environmentally friendly communities. By
        implementing this system, we strive for equitable access to electricity,
        enhancing the well-being of residents and safeguarding the environment
        for generations to come.
      </>
    ),
  },
];

export const SCHOLARS2023 = [
  {
    name: 'Green Allies',
    country: 'Cyprus',
    school: 'American Academy Limassol',
    photo: '/images/scholars2023/aal.jpeg',
    team: '/images/scholars2023/teams/allies.webp',
    description:
      'Earth is alerting for a local waste threat that demands immediate action to conserve marine and terrestrial life. Cyprus has 1.2 million citizens, each producing 600kg of wastes annually, out of which 94kg is plastic. Despite the environmental schemes introduced, Cyprus remains a high-ranked waste contributor of the EU, acting as our motive to seek solutions. A waste management strategy is implemented in coordination with our school community to enhance the hierarchy to prevent-collect-reuse-recycle wastes. Students are assigned into teams, each responsible for the collection, sorting and recycling of wastes disposed in coastal regions and landfill sites. For their contribution and as a way of securing future cooperation, students are rewarded with a participation certificate and CAS points. An online platform will attract other schools and investors, promoting our solution for increase in recycled wastes at a global scale and creating incentives to shift consumers’ behaviour into a waste-free world.',
  },
  {
    name: 'Earthonators',
    country: 'Türkiye',
    school: 'American Collegiate Institute',
    photo: '/images/scholars2023/aci.jpg',
    team: '/images/scholars2023/teams/earthonators.webp',
    description:
      'Our product is versatile when it comes to tackling issues concerning the environment. While making sure we are creating an option to go green on a budget we also focused on how many issues we can mention. Our diaper made out of orange mandarin peels and a pocket with a seed in it right under where the feces comes, mainly targets waste management with its biodegradable structure. It also prevents deforestation by providing an optimal condition for the seed to grow with a natural feces. The issue with diapers and how their waste is mostly overseen because of it being a necessity and the eco-friendly options in the market being way out of budget captured our attention and this leaded to the creation of our product. The rates of bearing a child and excessive use of diapers in our country also influenced our goal to create a biodegradable diaper.',
  },
  {
    name: 'Team İzmir-1',
    country: 'Türkiye',
    school: 'American Collegiate Institute',
    photo: '/images/scholars2023/aci.jpg',
    team: '/images/scholars2023/teams/izmir.webp',
    description:
      'As agriculture is integral to maintain human societies and involves the usage of natural resources, we believe that agricultural efficiency is key to solving a multitude of problems. In this search to achieve our goal, we determined that it would be best to develop a platform that would serve as an online educatory program for small scale producers and farmers throughout Turkey, that features courses designed with a perspective of systems approach, developing technologies and general knowledge to holistically improve agricultural literacy.',
  },
  {
    name: 'Koolwayan',
    country: 'Philippines',
    school: 'Ateneo de Manila Senior High School',
    photo: '/images/scholars2023/ateneo.png',
    team: '/images/scholars2023/teams/koolwayan.webp',
    description:
      'Koolwayan is a sustainable and eco-friendly roofing tile that modernizes traditional Filipino roofs. These roofing tiles are cost-efficient and locally available, leaving room to develop into a product that can be produced sustainably. Utilizing bamboo, abaca, bagasse, and coconut fibers, we have innovated roofing tiles that are not only typhoon-resistant but are also good insulators. This addresses the lack of insulation among average Filipino households and other infrastructures, especially during the hot, humid months. By offering an alternative to expensive steel roofing, we hope to jumpstart the trend towards greener construction. Join us in addressing environmental issues and providing necessary solutions for the masses. Beat the heat the kool way with Koolwayan!',
  },
  {
    name: 'Team Ammos',
    country: 'Jamaica',
    school: 'Campion College',
    photo: '/images/scholars2023/campion.png',
    team: '/images/scholars2023/teams/ammos.webp',
    description:
      'It is common, especially in Caribbean and Latin American countries, for one to go to the beach and be greeted by an unsightly line of seaweed. This is sargassum, a type of brown seaweed that produces hydrogen sulfide, a noisome, toxic gas, and creates anoxic ocean conditions, which damages marine life and by extension impacts human health, damages ecosystems, and breaks down the fishing and the tourism industries. Despite its disservices to the environment, sargassum is an incredibly versatile and valuable asset. We plan to revolutionise the construction industry using hardened and sun-dried sargassum to make adobe bricks. These bricks will provide an eco-friendly, durable, inexpensive building material that can be used to build affordable housing for low-income citizens. Our proposal will facilitate sargassum removal from the beaches, which will result in a boost in the tourism and fishing industries, job opportunities and the improvement of marine life and ecosystems.',
  },
  {
    name: 'BIOCYTE',
    country: 'Mexico',
    school: 'CECyTE Morelos',
    photo: '/images/scholars2023/cecyte.png',
    team: '/images/scholars2023/teams/biocyte.webp',
    description:
      'BIOCYTE is a biocoating base on components of natural origin to be used for the coating of fruits and vegetables to achieve a longer life post-harvest of foods. BIOCYTE is a coating that is made from recoverable waste generated from various completed processes, which reduces significantly the final cost of the product due to the low cost of obtaining raw material. On the other hand, making use of recoverable waste minimizes the generation of organic waste by the different sectors, giving thus a sustainable use of waste.',
  },
  {
    name: 'Step by Step',
    country: 'Spain',
    school: 'Col·legi Montserrat',
    photo: '/images/scholars2023/col-legi.png',
    team: '/images/scholars2023/teams/stepByStep.webp',
    description:
      'An average person walks around 6.000 steps a day. Can you imagine the amount of electricity that millions of people could produce every day around the world if there was a way to generate power by walking? In Step by Step, we designed a shoe insole that is able to produce energy and store it in a battery suitable for all kinds of shoes. With Step by Step, you will be able to obtain energy to charge your phone, tablet or any electronic devices just by walking. This will reduce the use of non-renewable energies and contribute to our planet by motivating people to walk more and improve their physical and mental health. We are five passionate students who want to offer our revolutionary way of creating clean, renewable energy accessible for everyone. Step by step, walking for a cleaner and more sustainable future.',
  },
  {
    name: 'Save the Environment',
    country: 'Palestine',
    school: 'Deir El-Balah Girls B - UNRWA',
    photo: null,
    team: '/images/scholars2023/teams/save.webp',
    description:
      '“Green concrete” (GC) is a revolutionary topic in the concrete industry. The objective of this project is to use several waste products as a partial substitute for the Portland cement to avoid the burden of waste disposal and to reduce energy consumption. Concrete wastes like rubble; silica sand; ceramic and marble waste; fly ash; rough sea sand; ceramsite; quarrying wastes; glass wastes; incinerator residue; red mud; stone punch; are the raw materials that can be used to make GC. Rubble crushers; cool factories and municipalities will be encouraged to supply the project with all necessary waste products to start manufacturing of GC. The production process involves the usage of these waste products in various percentages in order to explore innovative in GC best construction methods and to carry out extensive research on GC production methods. A pilot study has been launched, promising results were obtained and further research is needed.',
  },
  {
    name: 'Delavo',
    country: 'Türkiye',
    school: 'Bahçeşehir Koleji Diyarbakir',
    photo: '/images/scholars2023/bah.png',
    team: '/images/scholars2023/teams/delavo.webp',
    description:
      'Laundry costs more than most of us think. Apart from what is reflected on bills, the wastewater stemming from washing machines consist of toxic chemicals and nonbiodegradable substances that eventually contaminate soil or water and disrupt our ecosystem. Correspondingly our team, Delavo, developed ECaundry. Owing to its unique design and technology, ECaundry, a feasible device utilizing integrated hollow ultrafiltration tubes and carbon filter to treat and reuse the laundry wastewater, is a game-changer device to the issue of high water waste caused by washing machines. Saving up more than 90% water, ECaundry provides mutual advantage between our customers and environment.',
  },
  {
    name: 'Hemi Change',
    country: 'Türkiye',
    school: 'Bahçeşehir Koleji Diyarbakir',
    photo: '/images/scholars2023/bah.png',
    team: '/images/scholars2023/teams/hemi.webp',
    description:
      'Watermelon, rich in hemicellulose, is produced largely in our hometown thanks to the Tigris River. Yet, the microplastics in Tigris increasingly devastate agricultural production and harm biodiversity; 3/40 of fish species are under extinction risk in Tigris. The detrimental short-term effects on farmers and salespeople have long-term causes in society, like agricultural products with thawed microplastics. We want our local resources to be solutions and sustainability providers for the environment; thus, we created Hemi Change, a biodegradable and non-toxic plastic containing hemicellulose from watermelon and glycerol from soybeans, two of our hometown’s main agricultural products. We created our first prototype at Dicle University Biochemistry lab and tested how Hemi Change decomposes without realizing toxins, doesn’t react with oxygen like common plastics —providing healthier long-term usage— and is digestible, therefore, safer. Our globally-applicable model strives to decrease plastic pollution with bio-friendly plastic that improves agricultural production.',
  },
  {
    name: 'Wonder',
    country: 'Türkiye',
    school: 'Bahçeşehir Koleji Diyarbakir',
    photo: '/images/scholars2023/bah.png',
    team: '/images/scholars2023/teams/wonder.webp',
    description:
      'Looking for a warm place, animals prefer the interior parts of the car, causing them to lose their lives or get harmed. This long-standing problem also causes permanent damage to vehicles and biodiversity loss. Animal Savehicle is an Arduino-based circuit composed of touch, motion, and sound sensors to detect and deter animals from vehicle components. Once the sensors detect an animal, one of the speakers emits sound waves that can only be heard by animals while the other speakers and the LCD warn the driver. With the help of this, animals can be detracted from the vehicle without any damage.',
  },
  {
    name: 'HEVSEL',
    country: 'Türkiye',
    school: 'Bahçeşehir Koleji Diyarbakir',
    photo: '/images/scholars2023/bah.png',
    team: '/images/scholars2023/teams/hevsel.webp',
    description:
      "Fish populations die off from the excessive amount of toxic wastes every day and numerous people's health are affected by these also. As HEVSEL, we aim to eliminate this problem in the scope of hydrogen sulfide —a toxin that exists in anaerobic conditions and is known for its heaviness. Our designed and implemented device reduces this toxicity in the sewer pipes through an eco-friendly way which uses the functionality of oxygen production thanks to algae population that's hosted in one of the chambers within our prototype. We are at war with nature, if we win we will lose; save nature.",
  },
  {
    name: 'The Algean Immitators',
    country: 'Egypt',
    school: 'Elmenya STEM School',
    photo: '/images/scholars2023/menya.jpeg',
    team: '/images/scholars2023/teams/algean.webp',
    description:
      'Egypt is currently suffering from a shortage of water. The major challenge that we are trying to solve in our project is reducing the amount of clean water in Egypt, especially the water used in agriculture. This problem caused a decrease in the cultivation of some agricultural crops that need a large amount of water, such as rice cultivation. So for our solution, we found that marble factories produce about 15000L of water per day in the stage of cutting the marble. This contaminated water can be purified by using 2 treatments: the first treatment is using a filter paper to remove the undissolved solids in water, and the second treatment is by using a type of algae called Scenedesmus which can be found in the Nile river in Egypt. Our idea can benefit Egypt and increase the sources of fresh water in Egypt.',
  },
  {
    name: 'Earthify',
    country: 'United Kingdom',
    school: 'Eton College',
    photo: '/images/scholars2023/eton.png.webp',
    team: '/images/scholars2023/teams/earthify.webp',
    description:
      'Struck by the sheer amount of waste and heavy metals in rivers of the Niger Delta region, killing nearly 300,000 Nigerians annually, we decided to put forward a method of filtering water through biological means. As a team of 5 enthusiastic individuals, we discovered that the mycelium of the mushroom Pleurotus tuber-regium has properties ideal for water remediation. We manufacture hessian sacks layered with straw, wood chips and mushrooms; these are then provided to local Nigerian leaders to be distributed and placed in streams across the nation. The impact of our method is three-fold: neutralising acidic and alkaline waters, mycofiltering heavy metals to below the WHO limit, and decreasing bacteria count by 100 times.',
  },
  {
    name: 'Shell Wrap',
    country: 'United Kingdom',
    school: 'Eton College',
    photo: '/images/scholars2023/eton.png.webp',
    team: '/images/scholars2023/teams/shell.webp',
    description:
      'Shell Wrap plans to remove the unbiodegradable clingfilm baggage wrap options at airports (initially Heathrow) and replace them with our own environmentally friendly baggage wrap (which will be sold in stalls at the airport); in a partnership with CuanTec, a company that has developed the first viable films to replace plastic using chitin as its source material.',
  },
  {
    name: 'EcoShield',
    country: 'Israel',
    school: 'Givat Haviva International School',
    photo: '/images/scholars2023/ghis.png',
    team: '/images/scholars2023/teams/ecoshield.webp',
    description:
      'We are EcoShield, an innovative company that seeks to rid the world of its most elusive contaminant, microplastics. Its harmful effects — tissue damage, digestion problems, etc. — are recognized internationally. Our mission is to clean the water of PET plastics using a cutting-edge innovation: the enzyme capable of breaking down PET plastics into simpler more digestible monomers. Inspired by the production of lactose-free products, we came up with AquaBeads, little algae beads with PETase adsorbed to their surface. This way our fresh idea helps purify the water both domestically – house plants, water filters – and industrially – animal breeding, farming, and cosmetics.',
  },
  {
    name: 'The Micro Managers',
    country: 'Canada',
    school: 'Herzliah High School',
    photo: '/images/scholars2023/herlizah.png',
    team: '/images/scholars2023/teams/micro.webp',
    description:
      'Microplastics are becoming a global environmental problem, with increasing concern over their impact on human health. The widespread use of plastic products and poor waste management of these particles contribute to their accumulation, making microplastics a major challenger and extremely prominent. These tiny particles are found in our oceans, waterways, foods and more. As a team, we were able to create a product we call the "Water Wand". With the use of this product, people can safely and easily remove microplastics from their water as well as other substances. We wanted to create an affordable, transportable and simple solution to allow people to protect themselves against the microplastics and are proud to say we accomplished our goal.',
  },
  {
    name: 'JoinBike',
    country: 'Brazil',
    school: 'IFPR Campus Colombo',
    photo: '/images/scholars2023/ifpr.png',
    team: '/images/scholars2023/teams/joinbike.webp',
    description:
      'Combustion-powered cars are among the most responsible for the emission of polluting gases (such as CO²) on the planet, bringing immeasurable damage to air quality and contributing to global warming. Some alternatives that can help reverse this situation, such as the use of bicycles instead of cars, are unfortunately not encouraged as they should be. In Brazil alone, 4 cyclists die every day while pedaling, a serious and still very neglected number. When cycling in groups, the risks of running over plummet, and was with this in mind that the idea of JoinBike app came up. The application seeks to connect cyclists who still don’t know each other to book rides together and, consequently, practice cycling in a much more pleasant and safe way, in addition to financially rewarding cyclists for each kilometer pedaled, encouraging more and more people to assume a lifestyle active, healthy, and sustainable through biking.',
  },
  {
    name: 'Terraclu',
    country: 'United States',
    school: 'Illinois Mathematics and Science Academy',
    photo: '/images/scholars2023/imsa.png',
    team: '/images/scholars2023/teams/terraclu.jpeg',
    description:
      'Terraclu is a website and sensor system that predicts ethylene output levels of crops during climate controlled transportation and storage to recommend temperature and humidity changes, ensuring crops are delivered at the ideal ripeness while optimizing energy usage. The website features different platforms for retailers, transportation companies, and farms to ensure that crops are delivered at a ripeness level that corresponds with current supply to minimize waste.',
  },
  {
    name: 'LignIn',
    country: 'Vietnam',
    school: 'International School Ho Chi Minh City',
    photo: '/images/scholars2023/ishcmc.png.webp',
    team: '/images/scholars2023/teams/lignin.webp',
    description:
      'Deforestation is addressed as loofah papers can substitute tree paper and make use of abundant land resources where only tree barks remain due to past deforestation and utilize land as a scarce natural resource efficiently. With loofah plants having the capability to grow in these climates, deforestation can be addressed further there a cheaper alternative can be produced with an already existing natural resource.',
  },
  {
    name: 'Presidential School in Karshi',
    country: 'Uzbekistan',
    school: 'Karshi Presidential School',
    photo: '/images/scholars2023/psu.png',
    team: '/images/scholars2023/teams/presidential.webp',
    description:
      'This device of ours is practical for human activities related to agriculture and the environment, by increasing the labour productivity of farmers, and saving time. Additionally, the device helps to save a huge amount of water used for watering plants, prevent soil erosion and increase productivity. A water sensor and moisture measuring device are installed at the head of ditches in large cultivated fields, so that when water reaches it, the sensors measure its humidity and send a message to the farmer remotely via SMS module once the humidity reaches its standard. While the water is turned off and the standard humidity is given to the plant, this prevents excess water from escaping and the death of plants from the root to rot, and reduces yield due to excess water. We tested this device in practice and achieved our goal. Our team managed to save 3.7 times of water.',
  },
  {
    name: 'Avis',
    country: 'India / Digital',
    school: 'Khan World School',
    photo: '/images/scholars2023/khan.png',
    team: '/images/scholars2023/teams/khan.webp',
    description:
      'Through Avis, I want to make an impact on reducing biodiversity loss. Avis is an app that lets citizens volunteer to conduct ornithological surveys, freeing up professional ornithologists to focus on big-picture solutions. A locally-hosted neural network classifies any bird the camera points at; when multiplied by thousands of volunteers, these surveys start to become more wide-ranging and accurate. The app will create geotagged maps that will provide forest authorities with information on various regions so they can respond to situations on the ground. Using Avis, forest rangers, ornithologists, and citizens can all merge forces to help our planet’s avifauna.',
  },
  {
    name: 'AgriPod',
    country: 'United Kingdom',
    school: 'Leicester Grammar School',
    photo: '/images/scholars2023/leicester.png',
    team: '/images/scholars2023/teams/agri.webp',
    description:
      'Fertiliser waste destroys local communities - annually, 75 million tonnes of unused nitrogen fertiliser runs off into local groundwater and rivers, and decomposes to produce greenhouse gases. Many rural farmers disproportionately suffer from fertiliser misapplication owing to a lack of information about the conditions in their soil. In most cases, a simple change in timing can raise application efficiency by 45%. The AgriPod is an individually-tailored advisory system which handles data collection, processing and recommendations, detailing the optimal times for farmers to apply fertiliser. We’ve developed a network of coffee-cup sized sensors which gather live soil data from farmers’ fields for our algorithm to suggest a fertilising window to them. AgriPod couples environmental benefits with economic incentives to give farmers a low-cost solution that reduces their CO2 footprint - without impacting their income. Launching with a pilot in Northern India, AgriPod aims to slash fertiliser waste across the farming world.',
  },
  {
    name: 'Li Po Chun Carbon Audit',
    country: 'Hong Kong',
    school: 'Li Po Chun UWC',
    photo: '/images/scholars2023/uwc.jpeg',
    team: '/images/scholars2023/teams/lipo.webp',
    description:
      'The average annual global carbon footprint is 4 tons per person, (or 16 in certain countries). To avoid irreversible environmental damage, it has to reduce by 2 tons per person by 2050.How much carbon does a school emit? Our online Carbon Audit tool will help schools determine their starting point and areas of improvement. First, we will test the calculator in LPCUWC, and then make it available to other schools in Hong Kong. We hope to make school Carbon Audits accessible for students and teachers worldwide to learn, raise awareness, and join hands for a more sustainable future.',
  },
  {
    name: 'InvasiveAI',
    country: 'United States',
    school: 'Liberal Arts and Science Academy',
    photo: '/images/scholars2023/lasa.png',
    team: '/images/scholars2023/teams/invasive.webp',
    description:
      'Invasive species pose a significant threat to global biodiversity and overall ecosystem health.InvasiveAI is a service that aims to fight the crisis of invasive species globally. Through a novel app that leverages artificial intelligence technology, InvasiveAI can help farmers combat invasive species growth, through smart tracking, detection, and prevention methods.',
  },
  {
    name: 'Fins Off',
    country: 'Australia',
    school: 'Marist Sisters College Woolwich',
    photo: '/images/scholars2023/marist.jpeg',
    team: '/images/scholars2023/teams/finsoff.webp',
    description:
      'Surfboard wax is an absolute necessity for surfers, but it is not exactly environmentally sustainable. Every year, approximately 6 million bars of surf wax are used and discarded, with the vast bulk of it containing petrochemicals, which have numerous adverse effects on our marine environment, particularly reefs, as it is toxic to both marine life and coral. Our team, “Fins Off”, was influenced by the current pollution issue plaguing the Great Barrier Reef paired with the quintessential Australian surf and beach culture, ultimately leading to our proposal of biodegradable surfboard wax. The surfboard wax contains no petrochemicals and incorporates the active ingredient zooxanthellae; an algae known for replenishing coral and marine environments. Not only will our surfboard wax aid in preventing further destruction of our reefs, it will actively aid in their regeneration.',
  },
  {
    name: 'Gawrs',
    country: 'Belgium',
    school: 'Montgomery International School',
    photo: '/images/scholars2023/eim.png',
    team: '/images/scholars2023/teams/gawrs.webp',
    description:
      'Have you ever wanted to decrease your CO2 emission and water consumption while cooking? VeGo has got you covered. Download our app, select your option (if you are a vegan searching for more recipes or a meat-eater trying to go vegan), and access thousands of healthier, more environmentally friendly, vegan versions of dishes from different cuisines from all around the world. Not only we show you how to prepare the dish, we include the exact amount of each ingredient to avoid food waste, and also how much CO2 and water you save.',
  },
  {
    name: 'Clean Me!',
    country: 'United States',
    school: 'North Carolina School of Science and Mathematics',
    photo: '/images/scholars2023/north.jpeg',
    team: '/images/scholars2023/teams/cleanMe.webp',
    description:
      'Environmental pollution and neglect contribute to the destruction of millions of acres of land each year. While current solutions propose a methodical, municipal-based approach to minimizing environmental destruction, our team at NCSSM created CleanMe! — an environmental initiative consisting of an app and soil/water-sampling device focused on tackling environmental pollution through a citizen-science approach. CleanMe! gamifies environmental sustainability by introducing “EnviroCoins,” which can be accumulated through panoramas of one’s environment; EnviroCoins can be exchanged for environmentally friendly products from local (and international!) small businesses. Taken panoramas will be analyzed by our integrated A.I. and computer vision software, which can pinpoint physical environmental pollution. CleanMe! also allows citizens to alert local authorities and civilians to specific areas of hazardous environmental pollution with its interactive map. With CleanMe!, bringing attention to urgent, environmental issues will be more effortless and convenient than ever — especially for underrepresented and underprivileged local communities around the Earth.',
  },
  {
    name: 'AgriVision',
    country: 'United States',
    school: 'Polytechnic School',
    photo: '/images/scholars2023/polytechnic.png.gif',
    team: '/images/scholars2023/teams/agrivision.webp',
    description:
      'Food waste remains one of the greatest contributors to greenhouse gas emissions with over 1.3 billion tonnes of produce wasted each year. Yet unbeknownst to most people, 50% of food waste occurs early in the supply chain, and diseases are the leading cause of such crop loss. In response, we created AgriVision, the world’s first fully autonomous system that utilizes hyperspectral imaging and machine learning to conduct live plant health analysis on crops. By capturing normally hidden signs of disease or malnutrition in the earliest stages, AgriVision helps farmers improve harvest times, yield, quality, and, above all, minimize waste.',
  },
  {
    name: 'Green Tea-m',
    country: 'South Korea',
    school: 'Seoul Foreign School',
    photo: '/images/scholars2023/seoul.svg',
    team: '/images/scholars2023/teams/green.webp',
    description:
      'South Korea’s rivers suffer from eutrophication, or excess nutrient input resulting in the proliferation of algal blooms, which deplete oxygen in the water, suffocate aquatic life, and pose a threat to human health. The national eutrophication problem is due to Korea’s widespread agriculture industry and high levels of sewage disposal in natural environments. In terms of sewage contributions to riverine nitrogen input, the Republic of Korea ranks the highest in the world. Our Fresh Idea is a biomimetic filtration system, inspired by the filter-feeding mechanisms of manta rays. The cross-flow filtration method is specifically designed to remove the most prominent algae genera in rivers, and operates using flow of the river, making it completely electricity-free. With our proposed design, we hope to mitigate the effects of eutrophication in crucial freshwater sources.',
  },
  {
    name: 'Climate brawlers',
    country: 'Egypt',
    school: 'Sharkya STEM school',
    photo: '/images/scholars2023/sharkya.png',
    team: '/images/scholars2023/teams/climate.webp',
    description:
      'The project treats textile wastewater in an eco-friendly and cost-effective manner. Rice husk and cotton dust are prepared in 24 hours at 105°C and used to treat the water. The project consists of four main stages: (1) wastewater collection, (2) treatment by rice husk and cotton dust in 120 minutes, (3) gauging of water quality (pH and turbidity), (4) collection of treated water. All these are controlled by esp32 and Arduino to open pump and control sensors. The project is also connected with a mobile app, which allows users to monitor process conditions and view water quality data. Taken together, these stages offer effective methods for reducing the yearly 1.3 trillion gallons of polluted textile wastewater while ensuring safe usage in industry.',
  },
  {
    name: 'EW',
    country: 'Vietnam',
    school: 'Summit Education',
    photo: '/images/scholars2023/summit.png',
    team: '/images/scholars2023/teams/ew.webp',
    description:
      'Blending the dazzling beauty of art and our desire for sustainability, team “EW” is inspired to create a local art service that captures the aesthetic of traditional art through the repurposing of electronic waste. With the help of local artisans, the service will collect electronic waste materials from dumping sites and design them into cultural art products that not only meaningfully improve e-waste pollution but also create jobs and income for local artisans. We hope our service can change the public’s perception of e-waste and inspire people to reduce, repurpose and recycle e-waste.',
  },
  {
    name: 'WATER FAIRIES',
    country: 'Türkiye',
    school: 'Tarsus American College',
    photo: '/images/scholars2023/tarsus.png',
    team: '/images/scholars2023/teams/water.webp',
    description:
      'Are you aware of the hidden contents lurking in your local water resources? Well, fear not, because the Water Fairies has got you covered! Inspired by the mythological significance of water fairies as the protectors of aquatic life, we are on a mission to solve heavy metal water pollution. We utilize a specialized technique known as hydrothermal carbonization (HTC) to convert discarded tangerine and banana peels into eco-friendly and carbon-rich filters. With our team at the helm, we know that our HTC method will be a game-changer in the battle against water pollution. Join us on this journey as we pave the way for a cleaner, greener future!',
  },
  {
    name: 'Polygon',
    country: 'Costa Rica',
    school: 'UWC Costa Rica',
    photo: '/images/scholars2023/uwc-costa.png',
    team: '/images/scholars2023/teams/polygon.webp',
    description:
      "Our solution is a software that reduces excess consumer food waste caused by overlooked expiration dates. Every year, approximately 33% of purchased food is disposed of, with 20% caused by expiration date uncertainty. Carbon dioxide emissions from food waste exceed combined airplane, plastic production, and oil extraction emissions. Unawareness of food expiration dates creates a farm-to-landfill trajectory of organic nutritional waste. Our software increases users' awareness of their personal foodstuffs by alerting them when their food is on the cusp of expiration. This will limit household food waste from expiry and reduce the purchase of unnecessary foodstuffs when shopping. We are scaling our software by integrating with grocery stores to reach a larger user base and hope to expand to more cities in the future. Our mission is to improve global food consumption habits, and the Polygon software will make this possible for millions of people.",
  },
  {
    name: 'Keystone Oak',
    country: 'Netherlands',
    school: 'UWC Maastricht',
    photo: '/images/scholars2023/uwc-maastricht.png',
    team: '/images/scholars2023/teams/keystone.webp',
    description:
      'My solution tackles eutrophication, a severe issue affecting lakes in the Netherlands, by implementing algal turf scrubbers (ATS) made with recycled plastic and steel. Eutrophication occurs when excessive amounts of phosphorus and nitrogen, mainly from agricultural runoff and soil erosion, lead to harmful algal growth. This has environmental and human consequences, including biodiversity loss and threats to potable water. ATS reduces eutrophication by pumping water through screens covered with attached algal communities. The algae remove nutrients and produce oxygen, ultimately reducing eutrophication and the anoxic zones that it creates. To combat emissions from fossil fuels and animal overconsumption, the solution uses the harvested algae to create vegan dietary supplements and biogas. Omega-3 fatty acids will be extracted from the harvested algae and packaged in alginate capsules, replacing fish-based supplements that require intensive aquaculture or overfishing. The remaining biomass will be digested anaerobically to produce biogas for renewable energy.',
  },
  {
    name: 'Bactoplastics',
    country: 'United Kingdom',
    school: 'Winchester College',
    photo: '/images/scholars2023/winchester.png',
    team: '/images/scholars2023/teams/bactoplastics.webp',
    description:
      'Polyhydroxyalkanoates(PHA) are fully biodegradable thermoplastics, which are naturally produced by microorganisms for energy storage. We have designed a novel, cost-effective method for their production, which addresses the primary challenges in contemporary industrial PHA production. Our plastic substitutes most petroleum-based plastics for packaging (39.7% of global plastic production) and has potential to reduce plastic waste production by 67% in the UK. We are genetically engineering the bacterium Bacillus megaterium to upregulate PHA synthesis capability, and using inexpensively pre-treated food waste as the substrate for growth. Our product reduces pressure on landfills due to its 7-week degradation time, while repurposing up to 1.5 million tonnes of food waste annually. We are in the laboratory 20 hours/week, conducting dozens of biochemical experiments to identify optimal conditions for PHA production and food waste pre-treatment.',
  },
  {
    name: 'Veggie for schools',
    country: 'United Kingdom',
    school: 'Winchester College',
    photo: '/images/scholars2023/winchester.png',
    team: '/images/scholars2023/teams/veggie.webp',
    description:
      'Given that the processed meat industry contributes greatly to emissions worldwide, we think that a widespread change in diet is necessary to battle climate change. Introducing young people to sustainable eating is key in driving positive change, so we seek an increase in vegetarian food served in schools. We do not believe in forced vegetarianism, so we worked to create sustainable recipes that are school-friendly, that simply do not contain meat, and that have sufficient nutritional contents. As students ourselves, we believe that vegetarian food is not of high quality in schools, which creates a stigma around it. Thus, pupils are often dissuaded from taking up vegetarianism. Therefore, we are tackling the root of the problem with a cookbook full of cheap and delicious meals. Vegetarianism uses approximately five times less water than a meat-heavy diet, and the meat industry contributes significantly to emissions, so widespread vegetarianism in schools would make a significant difference.',
  },
];

export const SCHOLARS2022 = [
  {
    name: 'Team Joji',
    country: 'Australia',
    school: 'Alfred Deakin High School',
    photo: '/images/scholars/alfred.png',
    team: null,
    description: (
      <>
        Every year, Australians consume 8kgs of palm oil unknowingly, and every
        hour, the equivalent of about 300 football fields of rainforest are
        logged for palm oil, exacerbating global warming. We experienced the
        effects of climate change when Canberra was covered in thick smoke
        during the “Black Summer” bushfires last year.
        <br />
        <br />
        Our solution is simple: shift consumer behavior using engaging
        technology and gamification. A mobile game will teach consumers about
        unsustainable palm oil by using a unique learning model where consumers
        ‘meet’ real-world industry experts, plantation workers and environmental
        experts in augmented reality, making them appear in the supermarket
        aisle and putting faces to the facts. With a built-in ingredients lists
        scanner, our solution will empower consumers to pressure companies to
        switch to sustainable palm oil.
      </>
    ),
  },
  {
    name: 'ACI-Izmir-1',
    country: 'Türkiye',
    school: 'American Collegiate Institute',
    photo: '/images/scholars/aci.jpg',
    team: '/images/scholars/teams/aci.jpg',
    description: (
      <>
        The project tackles the mucilage problem observed in Marmara Sea which
        is a glue-like, thick substance that not only creates visual pollution
        but also damages the marine flora and fauna. It is a result of extreme
        contamination from factories and other sources of pollutants. Our
        solution involves removing the mucilage through a specifically
        engineered filter that will be installed on garbage collection bolts.
        <br />
        <br />
        We will convert the acquired waste into an alternative fertilizer to
        supply local farmers with fertilizer stock to aid the agricultural
        industry. Our project will approach this environmental disaster from
        both perspectives, ecocentric and technocentric, to provide a
        sustainable pollution management strategy.
      </>
    ),
  },
  {
    name: 'ASDubai: Waste to Wonder',
    country: 'United Arab Emirates',
    school: 'American School of Dubai',
    photo: '/images/scholars/asd.jpg',
    team: '/images/scholars/teams/asd.jpg',
    description:
      'Unlike many sports that require only a single ball to play, tennis is an extremely pollutant sport since the ball gets ruined quite easily and cannot be inflated. Therefore, a horrendous amount of tennis balls are thrown away ending up in landfills, there forming the additional waste into  greenhouse gasses, or in the sea, endangering millions of ecosystems in the ocean. We plan to create a platform that allows tennis enthusiasts and academies to collaborate with manufacturers in order to recycle and convert tennis ball material into useful products. We call it WasteToWonder.',
  },
  {
    name: 'The Trailblazers',
    country: 'India',
    school: 'Amity International School',
    photo: '/images/scholars/amity.jpeg',
    team: '/images/scholars/teams/trailblazers.jpeg',
    description: (
      <>
        Our proposed solution is to utilize food waste generated by homes,
        marketplaces and restaurants to generate sustainable energy and power
        for residential areas.
        <br />
        <br />
        The idea will be implemented by using an anaerobic digester. Anaerobic
        digestion is a process through which bacteria breaks down organic matter
        in the absence of oxygen. The energy required to maintain a suitable
        temperature inside the digester will be provided by solar panels. We
        will collect the food waste to provide power using sustainable energy
        while ensuring zero food waste.
      </>
    ),
  },
  {
    name: 'Planet rescures',
    country: 'Lebanon',
    school: 'Amqa Sec Coed',
    photo: null,
    team: '/images/scholars/teams/planet.jpg',
    description: (
      <>
        We have chosen to combat the plastic waste issue in our city of Lebanon
        using a certain type of mushroom known as pestalotiopsis microspora.
        This mushroom has the ability to break down polyurethane, the main
        constituent of plastic, even in the anaerobic medium. This mushroom is
        located in the Amazon rainforest and is very cheap compared to other
        alternatives. Our plan is to import the mushroom to Lebanon and set up a
        farm to plant it here. The mushroom can be used in landfills to
        completely get rid of any type of plastic waste.
      </>
    ),
  },
  {
    name: 'RenéMask',
    country: 'Armenia',
    school: 'Ayb School',
    photo: '/images/scholars/ayb.png',
    team: '/images/scholars/teams/renemask.png',
    description: (
      <>
        Personal protective equipment (PPE) items have become an integral part
        of our lives due to the global pandemic. The world seems to be more
        concerned about the shortage of PPE, while the environmental
        consequences of all the medical mask waste are being highly neglected.
        The most commonly used material for medical mask production is
        polypropylene, making the medical masks a source of fossil plastic and
        microplastic pollution.
        <br />
        <br />
        Our solution is a recycling method for medical masks which is based on
        thermal decomposition of polymers and fractional distillation. Thermal
        decomposition of masks is performed at elevated temperatures in an inert
        atmosphere that causes thermal degradation of long-chain polymer
        molecules into smaller molecules. RenéMask uses this thermochemical
        waste treatment technique as a solution to mask waste generation and
        mask pollution. After the recycling, distillation is used to separate
        the main products, which are the fuel and the biochar. As a result, the
        proposed solution mitigates plastic pollution in terms of masks, and
        creates an alternative source of energy to fossil fuels.
      </>
    ),
  },
  {
    name: 'Team Viridis',
    country: 'Jamaica',
    school: 'Campion College',
    photo: '/images/scholars/campion.png',
    team: '/images/scholars/teams/viridis.jpeg',
    description:
      "Our solution, 'Viridis', is a mobile application that facilitates the discounted sale of perfectly edible but superficially imperfect foods which supermarkets would have otherwise discarded. The discarding of food fit for consumption accounts for a quarter of the agricultural industry’s greenhouse gas emissions. Our platform would limit the food wastage, lower emissions, provide cheaper priced food to Jamaican citizens, and reduce the supermarkets monetary losses from food wastage, in order to incentivise the app’s usage. Team Viridis is driven by the fact that “the future is not someplace we are going to, but one we are creating.",
  },
  {
    name: 'CIECO',
    country: 'South Korea',
    school: 'Chadwick International School',
    photo: '/images/scholars/chadwick.gif',
    team: '/images/scholars/teams/cieco.jpg',
    description: (
      <>
        South Korea, despite being a small country that occupies 0.02% of the
        earth&apos;s surface, consumes 3.3 billion plastic cups annually. Our
        school, Chadwick International School, has an official Deli where
        students can purchase beverages such as smoothies, bubble teas, and
        lattes. As these beverages are served in disposable cups, members of the
        Chadwick community have become responsible for jettisoning 20,000 cups
        annually.
        <br />
        <br />
        Our proposed solution is to replace all plastic cups with reusable ones
        and adopt a reusable cup circulation system to collect them. The
        students can use the CIECO web application to rent out a reusable cup
        using their personal QR code and scanning the cup’s unique QR code. The
        students can throw away the reusable cups in the CIECO collection boxes
        installed across the school which will be collected by the CIECO members
        and transported to the cafeteria. The cups’ QR codes are scanned with an
        admin account which implies return, and they are stored in a UV
        sterilizer for reuse after washing. The solution will eliminate the
        waste produced by disposal cups in my school and also help reduce the
        detrimental effects of plastic. This solution could be applied in school
        cafeterias across other Korean schools as well as all over the world to
        encourage students to become environmentally conscious.
      </>
    ),
  },
  {
    name: 'ELYSIUM',
    country: 'India',
    school: 'DAV UNIT 8',
    photo: '/images/scholars/dav.png',
    team: '/images/scholars/teams/elysium.jpg',
    description: (
      <>
        Microplastics, which are smaller than a sesame seed and formed by the
        breakdown of larger plastic particles, wreak havoc on nature. These
        microscopic plastics are absorbed by various marine biota, eventually
        making their way up the food chain.
        <br />
        <br />
        We propose to create a model that will identify and detect microplastics
        as well as transmogrify microplastics into toxin-free and easily
        recyclable hybrid silica gel using the integration of Optical Particle
        Counting techniques and AI. Organosilanes, also known as silica sol, are
        employed in the collection process to generate hybrid silica gel by
        forming bonds with micro plastics. Our plan is to incorporate an
        autonomous system that detects microplastic concentrations underwater
        and collects them using organosilanes. Microplastics collected can be
        recycled or used for long-term purposes in a variety of industries. Our
        innovative model can also reach locations that would otherwise be
        uneconomical, such as the deep sea and the middle of oceans. In a
        nutshell, it can be utilized anywhere microplastics are present.
      </>
    ),
  },
  {
    name: 'Team 1',
    country: 'United Kingdom',
    school: 'Eton College',
    photo: '/images/scholars/eton.png',
    team: '/images/scholars/teams/team1.jpeg',
    description: (
      <>
        Global inequality increases with COVID and the environmental crisis, and
        we need to help the developing world make technological advances,
        particularly with respect to energy use. Solar panels produce almost 5%
        of electricity in the United Kingdom, but solar energy produces
        relatively little energy in the developing world. Using solar power as
        the energy source for school buildings would make a great impact on the
        use of non-renewable energy and emissions.
        <br />
        <br />
        The Collaborative Schools Solar Project is a groundbreaking effort for
        circumventing for-profit solar arrays that often do not benefit the
        local communities. CCSP creates an international network of schools,
        local policymakers, non-governmental organizations and philanthropists
        which work together to fundraise and catalyze behavioral change around
        decarbonising energy consumption in schools worldwide that would
        otherwise be unable to afford a photovoltaic array. Our pilot project is
        easily scalable and is a proof of concept. It will fundraise £50,000 for
        an 18.5kWp installation on Altwood School, a state school on the
        outskirts of Maidenhead, United Kingdom, and a 25kW installation on
        KwaThintwa School for the Deaf in KwaZulu Natal, South Africa.
      </>
    ),
  },
  {
    name: 'Non-Fungible Earth (NFE)',
    country: 'United Kingdom',
    school: 'Eton College',
    photo: '/images/scholars/eton.png',
    team: null,
    description:
      'We are currently in the world’s 6th mass extinction: 20% of mammals are nearly extinct, with 12+ being the current extinction rate per day. Between 14,000 and 35,000 species are at risk of extinction, with habitat loss being one of the main causes.The current rate of deforestation is 160,000 square kilometers per year, resulting in a major reduction in biodiversity and a whole host of related environmental problems. The solution lies in a simple, effective and scalable idea: Non-Fungible Earth (NFE) initiative. We will create unique, funky and cool NFT collections based around endangered animals and habitat restoration/maintenance to raise money and awareness in order to help restore and increase biodiversity around the world.',
  },
  {
    name: 'Team 4',
    country: 'United Kingdom',
    school: 'Eton College',
    photo: '/images/scholars/eton.png',
    team: '/images/scholars/teams/team4.jpeg',
    description:
      'Each year, 16,000 bodyboards are found littered all over British beaches. Most bodyboards are made from polystyrene, which breaks down into microplastics accounting for 11% of total ocean plastic pollution. The Ecoboard Initiative aims to tackle the growing rubbish problem on European beaches by targeting and limiting the desire for unrenewable bodyboards. These unrenewable boards are often mass produced and poorly made, snapping or eroding after just a few uses. We present an affordable, sleek and biodegradable alternate solution. The design uses two fundamental materials - cork and mushroom foam - to form a sustainable and fully biodegradable solution to the immense bodyboard pollution problem caused by the detrimental polystyrene in other body boards available on the market.\n',
  },
  {
    name: 'The Albedo',
    country: 'United Kingdom',
    school: 'Eton College',
    photo: '/images/scholars/eton.png',
    team: null,
    description: (
      <>
        The Earth&apos;s climate is warming, caused mainly by anthropogenic CO2
        emissions. These come from a myriad of sources, and decarbonising each
        economically would be a formidable task considering the time restraints.
        Solar power is a renewable energy solution, particularly effective
        between the tropics. However, the low albedo reflection of solar panels
        means that their use can have adverse effects on local and global
        climates, depending on the scale of deployment. Furthermore, high
        upfront costs can mean that solar projects are difficult to implement in
        developing countries, even considering the long-term cost benefits.
        <br />
        <br />
        Our solution is a floating machine that combines solar energy production
        with CO2 sequestration. Thousands of these machines will be connected
        into large networks located in carefully chosen parts of the ocean.
        Overall, this process will be able to remove ~1,900kg of
        CO2/machine/year. We would build up the network with the goal of
        eventually having 122 million individual machines which will be able to
        absorb 50GT of CO2/year.
      </>
    ),
  },
  {
    name: 'GREEN GAZA IV',
    country: 'Palestine',
    school: 'Gaza Training Center (GTC)',
    photo: null,
    team: '/images/scholars/teams/gaza.jpg',
    description: (
      <>
        The sewage problem is one of the biggest challenges facing the Gaza
        Strip. It is one of the leading causes of environmental pollution since
        sewage contains biological and chemical pollutants that affect humans,
        animals, plants, and the marine environment.
        <br />
        <br />
        As a team, we created a solution to this problem through the use of
        Cypress Roots (moist plants) to act as a filtering device for cleaning
        wastewater. The sewage water will pass through several stages until it
        becomes suitable for irrigation and showering. As the wastewater will
        flow from tank to tank at different altitudes, we will be able to
        generate renewable energy from the moving water. This solution will help
        solve the sewage problem affecting the Gaza Strip; furthermore, it will
        address the energy crisis. When the solution is successfully implemented
        in Gaza, we will offer to help implement it in every country that needs
        this project.
      </>
    ),
  },
  {
    name: 'Big GEMS',
    country: 'Taiwan',
    school: 'GEMS International Co., LTD.',
    photo: '/images/scholars/gems.jpg',
    team: '/images/scholars/teams/gems.jpeg',
    description:
      'We are team Big GEMS from Taiwan. The fast fashion industry nowadays emphasizes production efficiency and low cost, yet often ignores wastewater treatment. Textile factories in countries such as China, India, and Bangladesh release dye-containing wastewater directly into water sources, threatening the ecosystem and putting the health of locals at risk. From our research and experiments, we discovered the ability of fungi to degrade synthetic dye molecules; therefore, our proposal is to employ fungal enzymes to decolorize textile wastewater. We came up with the project name Dyelute and modeled the designs: Dyelute industrial filtering kits for degradation of factory dye wastewater, and the individual filtering kits for degradation of water sources used for daily life and irrigation. Our solution would help prevent potential harm to health as well as the ecosystem from dye pollution being released into the environment or being exposed to human bodies.',
  },
  {
    name: 'The Green Angels',
    country: 'India',
    school: 'Gyan Bharati School',
    photo: '/images/scholars/gyan.jpeg',
    team: '/images/scholars/teams/green.webp',
    description: (
      <>
        In rural areas, people lack the facility of a power supply, and
        sterilization is an immense problem during medical procedures. Proper
        sanitisation is not possible for those who need it due to the lack of
        sterilization, which is a human right, especially in these COVID times.
        The lack of hygiene causes people to get several diseases, which can
        result in death as well.
        <br />
        <br />I created the Solar Powered Portable UV Lamp which will provide
        sanitization during medical procedures in rural areas and will reduce
        air pollution to a great extent by eliminating the need to obtain a
        power supply through conventional sources of energy which are already
        affecting our Mother Earth adversely. This solution aims to save lives
        alongside its journey of saving the environment.
      </>
    ),
  },
  {
    name: 'Gators',
    country: 'Canada',
    school: 'Havergal College',
    photo: '/images/scholars/havergal.png',
    team: '/images/scholars/teams/gators.png',
    description:
      'We are Emily and Errita from Havergal College representing Team Gators. Living in Toronto, we have become ever more aware of the exponential level of pollution and greenhouse gas emissions dumped into Lake Ontario, Canada’s largest freshwater source. Alarming statistics show that lakes absorb more than a third of all carbon emissions and 90% of excess heat. Our solution is to create customized macroalgae farms for cities near the Great Lakes and partner with bioplastic manufacturers as a supply chain to promote sustainable consumerism. Macroalgae will remove toxins and carbon effectively and affordably, release oxygen, and restore a balanced environment. As members of the future generation, our team hopes to live in a world where humans finally become part of the environment and not a separate society.',
  },
  {
    name: 'FUTURACTIS',
    country: 'Switzerland',
    school: 'Institut Le Rosey',
    photo: '/images/scholars/rosey.png',
    team: '/images/scholars/teams/futuractis.jpg',
    description: (
      <>
        The Futuractis team decided to focus on the issue of crop residue
        burning and the use of fuel on farms. The combustion of crop residue
        releases significant amounts of CO2 into the atmosphere and the energy
        stored in the crops is lost. Our solution is the Biomass Vehicular
        Generator (BVG), a small electrical generator that uses the combustion
        of crop residue to produce electricity. The BVG will be installed
        directly on the farming equipment to instantly burn the crop residues to
        power the vehicle. The BVG not only reduces the CO2 emissions of crop
        burning, but also utilizes the unwanted residues to create electricity.
        In addition, the BVG integrated tractor will be a vehicle running on
        biomass energy from excess crop residue, which will eliminate both the
        issue of crop residues and encourage the transition to renewable energy
        for fueling tractors.
      </>
    ),
  },
  {
    name: 'ISPanama Care',
    country: 'Panama',
    school: 'International School of Panama',
    photo: '/images/scholars/panama.jpeg',
    team: '/images/scholars/teams/isp.jpeg',
    description: (
      <>
        ISPanama Care&apos;s goal is to solve the issue of the contamination of
        water bodies by organophosphorus pesticides, and the resulting
        environmental and health-related consequences on farmworkers and
        consumers in our region. We will be focusing on the agricultural regions
        of Los Santos, which have communities of farmers that are highly
        impacted by this issue.
        <br />
        <br />
        Our proposed solution includes three aspects: a synthetic biology
        approach, through a genetically modified cyanobacteria capable of
        degrading pesticides; a community outreach through a social study,
        education and awareness campaigns about the use of pesticides and
        necessary precautions; and lastly, drafting a proposed law including
        regulations addressing pesticide use in Panama.
      </>
    ),
  },
  {
    name: 'Aquaponics Training Center of West Africa',
    country: 'Switzerland',
    school: 'International School of Zug and Luzern',
    photo: '/images/scholars/iszl.jpg',
    team: '/images/scholars/teams/aquaponics.jpeg',
    description: (
      <>
        In close partnership with the non-profit KCC, located in Kokrobite,
        Ghana, ISZL students are designing a holistic regional training center
        and an aquaponics system to address environmental and economic issues
        facing traditional fishing villages along the coast of Ghana.
        <br />
        <br />
        Anchored by our new Sankofa Literacy Center, built out of 50,000 PET
        bottles with help from the entire community, we plan to offer community
        training in aquaponics system construction and operation, PET bottle
        construction techniques for buildings/rainwater storage, rocket stoves,
        and sustainable farming. Sankofa will also offer community services such
        as after-school programs, access to safe, clean water, and reusable
        menstrual pads for young women.
      </>
    ),
  },
  {
    name: 'JESS ECO TEAM 1',
    country: 'United Arab Emirates',
    school: 'Jumeirah English Speaking School, Arabian Ranches',
    photo: '/images/scholars/jumeirah.jpg',
    team: '/images/scholars/teams/jess.png',
    description: (
      <>
        Plastic bottles are used in the United Arab Emirates for the daily
        consumption of water and produce a massive wastage of energy as well as
        pollution. Our proposed solution is to implement a nationwide system in
        which we act as an intermediary between companies and households,
        incentivising the former and educating the latter to actively
        participate in replacing plastic bottles with glass bottles.To achieve
        this, we will collaborate with a waste disposal company that will
        transport used glass bottles from households to our warehouse. The glass
        bottles will be sorted according to their company of origin and will be
        taken back to the firms, to be cleaned and re-used to package water.
        This will effectively reduce energy and plastic wastage due to excessive
        production of plastic bottles in the market. This proposed solution will
        have to be approved by the government and financed by a range of
        sectors.
      </>
    ),
  },
  {
    name: 'APEH_7',
    country: 'India',
    school: 'KRM PUBLIC SCHOOL',
    photo: '/images/scholars/krm.jpeg',
    team: '/images/scholars/teams/apeh.jpg',
    description: (
      <>
        The fundamental driver of my research was the growing demand for
        electrical energy and rising air pollution around the world. I have
        invented a device, MEPAP - Multisource Electricity Producer Integrated
        with Air Purifier, that uses multiple sources for electricity generation
        such as vibration, electromagnetic radiation, thermal, solar energy and
        wind energy in order to reduce our dependence on fossil fuels for
        electricity. MEPAP has advanced air purifiers which use wash coat
        technology using silica with silicon dioxide and alumina to make it
        purify from the source itself. The motto of the device is “Reduce
        Pollution” with the motive “GO GREEN and prevent shortage by utilizing
        the wastage”. The main objective of my idea is to produce self-powered
        vehicles - EV, charging stations and other devices using my MEPAP - to
        reduce pollution.
      </>
    ),
  },
  {
    name: 'LivingEnergy',
    country: 'Spain',
    school: 'Liceo Europeo',
    photo: '/images/scholars/liceo.png',
    team: '/images/scholars/teams/living.jpg',
    description: (
      <>
        LivingEnergy aims to face the problem of plastic pollution, which has
        been exacerbated by pandemic-related waste, especially facemasks. We are
        aiming to convert this plastic into electricity by using a technology
        known as microbial fuel cells. These use microorganisms to couple power
        generation and residue degradation. Our initial prototype could produce
        more than 500 kWh of electricity a year through facemask degradation,
        and could also be used with other residues, such as food waste and
        wastewater. This prototype has the potential to be scaled up and used to
        produce energy to power devices as well as meeting the electrical demand
        in developing communities.
      </>
    ),
  },
  {
    name: 'net zerO HEROES',
    country: 'Canada',
    school: 'Our Lady of the Snows Catholic Academy',
    photo: '/images/scholars/lady.png',
    team: '/images/scholars/teams/zero.jpg',
    description:
      'BORN to REWILD is a rewilding retrofit project in which plots of non-recreational school grounds will be restored annually into small areas of native plant species - one school plot at a time. The most viable indigenous plants will be used that are water-efficient, sequester the most carbon, withstand extreme temperature and have minimal maintenance. The goals of this project are improved water efficiency, reduced runoff of pesticides and fertilizers, increased carbon sequestration, and resolving the lack of biodiversity in urban landscapes. Additionally, the project will be integrated annually into the fourth-grade school curriculum. This legacy project scales towards the rewilding of residential urban front lawns that would serve as a non-profit revenue stream for economic sustainability.',
  },
  {
    name: 'The Reefs',
    country: 'Dominican Republic',
    school: 'Puntacana International School',
    photo: '/images/scholars/pcis.jpg',
    team: '/images/scholars/teams/reefs.jpeg',
    description: (
      <>
        There are few habitats in the global ecosystem as necessary to preserve
        as coral reefs. Yet we continue to damage them, even in subtle ways that
        many do not realize such as through cosmetics. Chemicals like
        benzophenone-2 used in UV-absorbent products have adverse effects on
        coral reefs, including bleaching, mutations, and destruction.
        <br />
        <br />
        Our product, Sunreefs Sunscreen, aims to create a reef-safe and
        ecologically friendly product that will reduce the amount of toxic
        substances and plastic packaging in our oceans. It will also raise
        awareness of the dire situation of marine habitats today. Though a small
        change, switching to reef-safe sunscreen will have a big impact. We hope
        to contribute to that change.
      </>
    ),
  },
  {
    name: 'Baywatchers',
    country: 'Dominican Republic',
    school: 'Puntacana International School',
    photo: '/images/scholars/pcis.jpg',
    team: '/images/scholars/teams/baywatchers.jpeg',
    description: (
      <>
        Beautiful sights in the Caribbean, especially in the Dominican Republic,
        have been ravaged by sargassum, an invasive macroalgae that releases
        harmful gasses and disrupts entire ecosystems. This contributes to the
        pollution of water supplies, which are already inaccessible to 26% of
        the country&apos;s citizens.
        <br />
        <br />
        Our solution can turn sargassum into activated carbon, which can be used
        to create granular activated carbon (GAC) filters. We decided to develop
        this reverse osmosis filtration system using sargassum’s filtering
        properties. Setting up “Filtration Stations” in lower-income
        neighborhoods will provide a reliable source of clean water to
        Dominicans who would not have access to it otherwise. Users of this
        service will simply approach the water filtration station and refill
        their tanks for an affordable price.
      </>
    ),
  },
  {
    name: 'Kibra waste recyclers',
    country: 'Kenya',
    school: 'Raila Educational Centre',
    photo: '/images/scholars/raila.jpeg',
    team: '/images/scholars/teams/kibra.jpg',
    description: (
      <>
        Our school, Raila Educational Centre, is situated in Kibera, which is
        one of the largest informal settlements in Africa. The Kibra Waste
        Recyclers have been concerned about the amount of waste paper our school
        generates from notebooks and printed material which is burnt in
        landfills, releasing greenhouse gasses. In addition, the school uses
        firewood equivalent to four mature trees per week to cook two meals
        daily for all the students, thus contributing to deforestation.
        <br />
        <br />
        In an effort to reduce pollution and deforestation, we convert the waste
        paper into briquettes made out of paper waste and sawdust to produce
        energy for cooking our meals. In order to implement the idea, we have
        collaborated with the local community and neighboring schools to collect
        waste paper in designated collection bags at schools for recycling.
        <br />
        <br />
        This will help to create awareness about the effects of burning waste
        paper, reduce emissions, and save available trees in order to attain the
        10% forest cover meant to be achieved in Kenya by 2022. The community
        will benefit from learning how to make briquettes and from selling them
        to earn income.
      </>
    ),
  },
  {
    name: 'ADORBSIES',
    country: 'Vietnam',
    school: 'Summit Education',
    photo: '/images/scholars/summit.png',
    team: '/images/scholars/teams/adorbsies.png',
    description:
      'We’re Adorbsy, a biodegradable pad brand that aims to promote environmental consciousness behind menstruation, for the health of women and Mother Nature. Plastic-based sanitary pads can take up to 800 years to degrade, severely polluting the Earth upon disposal. As the world’s largest dragon fruit supplier, Vietnam produces over a million tonnes per year. Dragon fruit peels can be processed into environmentally-friendly bioplastics that can replace the non-degradable components of menstrual pads. We hope that this fresh idea can open up new possibilities for creating a biodegradable pad that incorporates upcycling of a locally abundant agricultural produce in the region.',
  },
  {
    name: 'Sensible Saiyans',
    country: 'Indonesia',
    school: 'Surabaya European School',
    photo: '/images/scholars/ses.png',
    team: '/images/scholars/teams/sensible.png',
    description: (
      <>
        Our team aims to solve the issue of excessive plastic waste and its
        subsequent poor management. This is a global problem, but we aim to
        address it on a national level first since Indonesia is one of the
        biggest plastic waste contributors in the world. Therefore, our proposed
        solution is to introduce a new government policy: tax reductions of 10%
        for businesses that make products containing a minimum of 20% recycled
        plastic. This will give businesses a financial incentive to buy and use
        more recycled plastic, which will lead to an increased demand for it,
        resulting in the growth of the plastic recycling industry. More
        businesses would be interested in the plastic recycling industry as they
        will see its profitability. Subsequently, there will be an overall
        decrease in plastic waste.
      </>
    ),
  },
  {
    name: 'Innovative Solution',
    country: 'Bhutan',
    school: 'The Royal Academy',
    photo: '/images/scholars/royal.png',
    team: '/images/scholars/teams/innovative.jpg',
    description: (
      <>
        Plastics are not just a waste-related issue; they are also a hazardous
        contributor to climate change. It&apos;s a 100% man-made problem. Bhutan
        is known as the only country in the world that measures development
        through a Gross National Happiness index. What many people do not know
        is that it is a carbon negative country too. However, this has not
        protected us from plastic pollution.
        <br />
        <br />
        We will help resolve two problems with our solution to upcycle rice
        sacks into pencil bags. Every year, Bhutanese students spend USD180,000
        to USD300,000 on pencil bags mostly made of plastics. With our solution,
        we will reduce the amount of plastic (including rice bags which are also
        made of plastic) going into the landfills and polluting the environment,
        while contributing to the economy of the country whose GDP is less than
        USD3 billion. This is a simple, effective and sustainable approach which
        can be implemented in any corner of the world.
      </>
    ),
  },
  {
    name: 'UWC-USA',
    country: 'United States',
    school: 'UWC-USA',
    photo: '/images/scholars/uwc.gif',
    team: '/images/scholars/teams/uwc.jpg',
    description: (
      <>
        New Mexico is one of the most arid regions in the United States. It
        relies heavily on surface water and has serious sedimentation problems,
        especially in the Rio Grande area. Most of New Mexico’s gross domestic
        product comes from fracking and mining which contaminate water bodies,
        as well as acid mine drainage that pollutes freshwater streams and
        rivers.The contaminated water leads to a loss of biodiversity. The
        agricultural use and consumption of polluted water also adds a huge
        burden to the healthcare system.
        <br />
        <br />
        Our project is to construct water gardens by placing native plants in
        local rivers to purify the water. We have researched plants that fit our
        geographical location and have the specific qualities to remove
        sediments from polluted water sources. The water gardens will filter
        surface water in rivers naturally and improve the water quality while
        also reducing the amount of pollution caused by sedimentation.
      </>
    ),
  },
  {
    name: 'Bioclear',
    country: 'United Kingdom',
    school: 'Wimbledon High School',
    photo: '/images/scholars/wim.png',
    team: '/images/scholars/teams/bioclear.jpg',
    description: (
      <>
        Destroying aquatic ecosystems, microplastic pollution has detrimental
        impacts on animal and human life, as well as economic ramifications.
        Furthermore, there are currently no solutions. However, our water-borne
        robots, BioClears, could be the answer. They are ochre, spherical robots
        (30cm diameter) operating aquatically which use innovative and
        cost-efficient technology to detect, research, and remove microplastics
        from aquatic bodies. Practical and durable, the robots are low
        maintenance: self-navigating, charging, and reporting damage.
        Furthermore, BioClears have optimal environmental safety and can be
        adapted to suit practically every water ecosystem. BioClears, when
        distributed, should eradicate microplastics from all aquatic bodies
        safely and efficiently.
      </>
    ),
  },
  {
    name: 'CwN Team #1',
    country: 'United Arab Emirates',
    school: 'Emirates Nature - WWF Connect with Nature program',
    photo: '/images/scholars/cwn.png',
    team: '/images/scholars/teams/cwn.jpeg',
    description: (
      <>
        Being part of the youth climate movement, we realized that many people
        are interested in helping the environment but just do not know where to
        start. Furthermore, hundreds of environmental organizations are making a
        big difference but operating at an underfunded capacity.
        <br />
        <br />
        Our solution is to develop a platform where anyone can easily find
        environmental organizations to volunteer, fund or partner with through
        an app. Our aim is to support and increase the education, collaboration
        and accessibility of climate action by connecting relevant stakeholders
        and building meaningful communities. After completing a preference quiz,
        a person will be matched with environmental organizations and events
        that align with their interests. Investors, businesses, and grassroots
        organizations from around the world can also be matched based on their
        values and interests.
      </>
    ),
  },
  {
    name: 'Smart Bins',
    country: 'Sri Lanka',
    school: 'Zahira College',
    photo: '/images/scholars/zahira.png',
    team: '/images/scholars/teams/smart.jpg',
    description: (
      <>
        Millions of bins end up overflowing before being collected, causing
        dirty streets, bad odors and negative health and environmental impacts.
        Overflowing bins are an ideal breeding ground for bacteria, insects and
        vermin. As a solution, I developed 3 types of smart bins based on
        different sectors (Domestic Use, City Use, Industrial Use) loaded with
        advanced waste management systems and smart features using robotics and
        IoT technologies. Smart Bins prevent overflowing of bins, provide a
        clean environment, reduce garbage truck routes which reduces fuel
        consumption, CO2 emissions as well as noise and pollution. Smart bins
        contribute towards four UN Sustainable Development Goals and provide
        solutions for many problems that we face in our day-to-day lives.
      </>
    ),
  },
];
